/* eslint-disable  */
import React, { Fragment, Dispatch, useState, useEffect } from "react";
import "./OrderHistory.css";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ReturnRequestSnackbar from "../../common/components/returnRequestSnackbar";
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import ReplayIcon from "@material-ui/icons/Replay";
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Collapse from '@material-ui/core/Collapse';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Add from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Tooltip from '@material-ui/core/Tooltip';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import DatePicker from '../../common/components/dateRangePicker';
import Checkbox from "@material-ui/core/Checkbox";
import { getOrdersList, getOrderId, getInvoice, resetInvoice, setPageNumber, getOrderStatus } from "../../store/actions/orderHistory.actions";
import moment from "moment-timezone";
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import { isEmpty, isString } from 'lodash';
import FullscreenLoader from "../../common/components/FullscreenLoader";
import { RESTRICTED_ACCESS } from "../../constants/restrictedAccessConstants";
import NotificationIcon from "../../common/components/NotificationIcon";
import { getDeliveryList } from "../../store/actions/delivery.actions";
import { getNewBrand, getDisplayNameBySalesOffice, getCustomerFilterOptions } from "../../common/components/util";
import { useCallback } from "react";
import { ALL_STATUS, viewDeliveryOrderStatuses } from "../../constants/orderHistoryConstants";
import { getSellingPrice } from "../../helpers/commonmethod";
import Dialog from '@material-ui/core/Dialog';
import HistoryMakePaymentDialog from "../CreateEnquiry/OrderHistoryMakePaymentDialog";
import OrderHistoryPayment from "./OrderHistoryPayment";
import { getCreditLimit } from "../../store/actions/creditLimit.actions";
import _, { get } from "lodash";
import { getOrderSummary } from '../../store/actions/orderSummary.actions';
import { ViewDelivery } from "../../store/actions/delivery.actions";
import { selectedViewDelivery } from "../../store/actions/delivery.actions";
import { getOrderSummaryDetails } from '../../store/actions/orderSummary.actions';
import { getViewRequestStatusAPI } from "../../store/actions/requestSpecialPrice.actions";
import { isVewingFromOrderHistory } from "../../store/actions/orderHistory.actions"
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import HelpIcon from "@material-ui/icons/Help"
import { quotationDetailsViewOrder } from "../../store/actions/quotation.action";
import UploadLpoViewOrder from "./UploadLpoViewOrder";
import OrderHistoryViewQuotation from "../Quotation/OrderHistoryViewQuotation";
import { downloadQuotation, viewLPO } from "../../store/actions/quotation.action";
import OrderHistoryViewLPO from "../Quotation/OrderHistoryViewLPODialog";
import Menu, { MenuProps } from '@material-ui/core/Menu';
import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import SearchIcon from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import ListItemText from '@material-ui/core/ListItemText';
import { getFSECustomerList, getCustomerDetailsByCustomerID } from "../../store/actions/dealer.action";
import { getFSEList } from '../../store/actions/orderEnquiry.action';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import clsx from 'clsx';
import { getProfile } from "../../store/actions/profile.action";

const useStyles = makeStyles((theme) => ({
  collapseBg: {
    background: 'rgba(66, 94, 108, 0.07)'
  },
  rowHighlight: {
    background: 'rgba(67, 95, 107, 0.15)',
    color: '#666666',
    fontWeight: 700
  },
  orangeRowHighlight: {
    background: 'rgba(240, 223, 0, 0.12)',
    color: '#666666',
    fontWeight: 700
  },
  bodyContent: {
    color: '#666666',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    width: 140,
  },
  iconSlot: {
    width: 14,         // ≈ icon (10) + 4px gap
    height: 10,        // only needed for vertical centering
    display: 'inline-block'
  },
  annexurePart: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#03121d',
    display: 'inline-block',
    marginRight: 6
  },
  bodyContentRed: {
    color: 'red',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    width: 140,
  },
  bodyContentSmall: {
    color: '#666666',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    width: 40,
  },
  collapseIcon: {
    color: '#000000',
    fontWeight: 500,
  },
  tableHeadSmall: {
    color: '#133F8A',
    fontWeight: 900,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    lineHeight: 0,
    width: 40,
  },
  tableHeadForOrderNo: {
    color: '#133F8A',
    fontWeight: 900,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    minWidth: 70,
    paddingLeft: 18,   // reduced from 25 to better align
    paddingRight: 6    // slight right spacing if needed
  },
  tableHead: {
    color: '#133F8A',
    fontWeight: 900,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    lineHeight: 0,
    width: 140,
  },
  subTableHead: {
    color: '#444444',
    fontWeight: 800,
    width: 140,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
  },
  subTableHeadSmall: {
    color: '#444444',
    fontWeight: 800,
    width: 40,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
  },
  actionButton: {
    color: '#1A9FE0',
  },
  subTableBodyContent: {
    color: '#666666',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    width: 140,
  },
  subTableBodyContentRed: {
    color: 'red',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    width: 140,
  },
  subTableBodyContentSmall: {
    color: '#666666',
    fontWeight: 600,
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    padding: 10,
    width: 40,
  },
  actionRequest: {
    color: "white",
    background: "#1A9FE0",
    border: "2px solid #1A9FE0",
    borderRadius: "8px",
    width: "1rem",
    height: "1rem",
    "&:hover": {
      background: "#1A9FE0",
      color: "white !important",
      borderRadius: "14px",
      width: "1rem",
      height: "1rem",

    },
  },
  toggleGroup: {
    marginRight: 12,
  },
  toggleBtn: {
    fontSize: '0.9rem',
    padding: '6px 20px',
    border: '1px solid #1A9FE0 !important',
    textTransform: 'none',
    color: '#1A9FE0',
    '&.Mui-selected': {
      backgroundColor: '#1A9FE0',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#1A9FE0',
      },
    },
  },
  toggleBtnLeft: {
    borderRadius: '50px 0 0 50px !important',
  },
  toggleBtnRight: {
    borderRadius: '0 50px 50px 0 !important',
  },
}));

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const normalizeCustomerTypeLabel = (label: any) => {
  if (!label) return '';
  return label.toString().replace(/\(.*?\)/g, '').trim().toLowerCase();
};

const NORMALIZED_CUSTOMER_TYPE_MAP: { [key: string]: string } = {
  dealer: 'dealer',
  workshop: 'workshop',
  government: 'government',
  fleet: 'fleet',
  'tpc dealer': 'tpcdealer',
  'tbl dealer': 'tbl dealer',
  'int. business': 'int. business',
  'int business': 'int. business',
};

const getSreCustomerTypeKey = (label: any) => {
  if (!label || label === 'All') return 'All';
  const normalized = normalizeCustomerTypeLabel(label);
  const mapped = NORMALIZED_CUSTOMER_TYPE_MAP[normalized];
  // eslint-disable-next-line no-console
  console.log('[SRE CustomerType] raw label:', label, '| normalized:', normalized, '| mapped key:', mapped || label);
  return mapped || label;
};

const OrderHistory: React.FC = () => {
  const history = useHistory();
  const [isReturned, setIsReturned] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 10;
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();
  const [openReturnRequest, setOpenReturnRequest] = React.useState(false);
  const [openReturnRequestSnackbar, setOpenReturnRequestSnackbar] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const dataOrderRedux: any = useSelector((state: any) => state.orderEnquiry);
  const { orderList, invoice, prevPage, orderStatus, orderDetails, partsHistoryList }: any = useSelector((state: any) => state.orderHistory);
  const [selectedOrder, setselectedOrder] = React.useState<any>(null);
  const [actualOrder, setActualOrder] = React.useState<any>(null);
  const [searchText, setsearchText] = useState<any>('');
  const [committedSearch, setCommittedSearch] = useState("")
  const [allCustomers, setAllCustomers] = React.useState<any[]>([]);
  const [filterByCustomer, setFilterByCustomer] = React.useState(sessionStorage.getItem('userType') === 'sre' ? "All" : '')
  const [isMyOrders, setisMyOrders] = useState<boolean>(true);
  const today = moment(new Date());
  const [totalOrderCount, setTotalOrderCount] = React.useState<any>(0);

  // Deployment date constants
  const DEPLOYMENT_DATE = moment('2026-09-01', 'YYYY-MM-DD');
  const ONE_MONTH_BEFORE_DEPLOYMENT = DEPLOYMENT_DATE.clone().subtract(1, 'month');
  // SRE-only: fallback lower bound when searching Old Orders by number with
  // the date filter cleared — wide enough not to exclude legit older
  // records, still capped at deployment date.
  const OLD_ORDERS_SEARCH_START_DATE = moment('2000-01-01', 'YYYY-MM-DD');
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

  // Convert Date object to moment object
  const momentDate = moment(thirtyDaysAgo);

  // Format the date with day, month, year, hours, minutes, seconds, and timezone
  let formattedDate: any = momentDate.format('ddd MMM DD YYYY HH:mm:ss');
  formattedDate = moment(new Date(formattedDate));

  // Default to Old Orders date range
  // const [startDate, setstartDate] = useState<any>(DEPLOYMENT_DATE);
  // const [endDate, setendDate] = useState<any>(today);

  const daysDiffFromDeployment = today.diff(DEPLOYMENT_DATE, 'days');
  const newOrdersDefaultStartDate = daysDiffFromDeployment <= 31 ? DEPLOYMENT_DATE : today.clone().subtract(31, 'days');

  const [startDate, setstartDate] = useState<any>(newOrdersDefaultStartDate);
  const [endDate, setendDate] = useState<any>(today);

  const [searchByInvoice, setSearchByInvoice] = useState("")
  const [status, setstatus] = useState<any>("");
  const [open, setOpen] = React.useState(-1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [customerAnchorEl, setCustomerAnchorEl] = React.useState<null | HTMLElement>(null);
  const [goodsStatus, setGoodsStatus] = React.useState('');
  const [status24, set24hrsStatus] = React.useState('');
  const [fileExtention, setFileExtension] = React.useState('pdf');
  const [viewQuotationUrl, setViewQuotationUrl] = React.useState("")
  const { profileDetails, isSellingPriceData }: any = useSelector((state: any) => state.profileDetails);
  let customerAccountType = get(profileDetails, 'data.data.customerInfo.customerAccountType', '');
  const markupPercentage = get(profileDetails, 'data.data.customerInfo.markupPercentage', false);
  const isSalesReturnAccess = get(profileDetails, 'data.data.customerInfo.isSalesReturnAccess', true);
  const salesOrganization = get(profileDetails, 'data.data.basicInfo.salesOrganization', []);
  const isArchAutoOrgProfile = Array.isArray(salesOrganization) && salesOrganization.some((so: any) => so?.salesOrganization === '2428');
  const { deliveryList }: any = useSelector((state: any) => state.delivery);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [Order, setOrder] = React.useState<any>("");
  const b2cUserId = get(profileDetails, "data.data.basicInfo.b2cUserId", "");
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [errorMessage, showErrorMessage] = React.useState<any>(null);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [payment, setPayment] = React.useState(false)
  const showViewInvoice = (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.DOwNLOAD_INVOICE_EXCEL) && !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.LIST_BILLING_DOCS);
  const showViewDelivery = (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.VIEW_DELIVERY);
  const sapCustomerId = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
  const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
  const customerTierType = (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') ? sessionStorage.getItem('customerTierType') ? sessionStorage.getItem('customerTierType') : get(profileDetails, 'data.data.customerInfo.customerTierType', '') : get(profileDetails, 'data.data.customerInfo.customerTierType', '');
  const [openViewQuotation, setOpenViewQuotation] = React.useState(false);
  const [openUploadLpo, setOpenUploadLpo] = React.useState(false);
  const [isLPOUpdate, isUpdateLPO] = React.useState(false);
  const [openViewLPO, setOpenViewLPO] = React.useState(false);
  const customerTypeAccess = get(profileDetails, 'data.data.basicInfo.customerTypeAccess', '');
  const [quotationNumber, setQuotationNumber] = React.useState("")
  const [enquiryNumber, setEnquiryNumber] = React.useState("");
  const [brandId, setBrandId] = React.useState("");
  const [orderNumber, setOrderNumber] = React.useState("");
  const [lpoAttachments, setLpoAttachments] = React.useState<any>([])
  const { getCustomerDetailsBySapId, getFSECustomerListData, getFSEEnquiryStatusData }: any = useSelector((state: any) => state.dealer);
  const [searchTextByID, setSearchTextByID] = React.useState<any>('');
  const [customerId, setCustomerId] = React.useState<any>([]);
  const [selectedCustomerId, setSelectedCustomerId] = React.useState<any>('');
  const [selectedCustomerName, setSelectedCustomerName] = React.useState<any>('');
  const [count, setCount] = React.useState<any>();
  const [anchorElForCustomer, setAnchorElForCustomer] = React.useState<null | HTMLElement>(null);
  const [loading, setLoading] = React.useState<any>(false);
  const [isQueuedEnquirieChecked, setIsQueuedEnquirieChecked] = useState(false)
  const [fseName, setFseName] = useState<any>(sessionStorage.getItem('webApplicationLoginId'));
  const { enquiryList, enquiryStatus, fseList } = useSelector((state: any) => state.orderEnquiry);
  const [fseWebApplicationLoginId, setFseWebApplicationLoginId] = React.useState<any>("");
  const [filterByStatus, setFilterByStatus] = React.useState<any>('All');
  const userType: any = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo?.userType) || "";
  const [isAnnexureCorePartChecked, setIsAnnexureCorePartChecked] = useState(false);
  const [orderType, setOrderType] = useState<string>("new");
  const loadOrderListRequestIdRef = React.useRef(0);

  useEffect(() => {
    sessionStorage.setItem("orderType", orderType);
  }, [orderType]);

  useEffect(() => {
    if (page === 0 && orderList && orderList.data && orderList.totalCount !== undefined && orderList.totalCount !== null) {
      setTotalOrderCount(orderList.totalCount);
    }
  }, [orderList, page]);

  const handleOrderType = (event: any, newOrderType: string) => {
    if (newOrderType !== null) {
      setOrderType(newOrderType);
      let newStartDate: any;
      let newEndDate: any;
      if (newOrderType === "old") {
        newStartDate = ONE_MONTH_BEFORE_DEPLOYMENT;
        newEndDate = DEPLOYMENT_DATE;
      } else {
        // newStartDate = DEPLOYMENT_DATE;
        // newEndDate = today;
        const daysDiff = today.diff(DEPLOYMENT_DATE, 'days');
        newStartDate = daysDiff <= 31 ? DEPLOYMENT_DATE : today.clone().subtract(31, 'days');
        newEndDate = today;
      }
      setstartDate(newStartDate);
      setendDate(newEndDate);
      setPage(0);
      setsearchText('');
      setstatus('');

      // Build searchData and call API immediately with new dates
      let searchData: any = {};
      searchData["fromDate"] = moment(newStartDate).format('YYYY-MM-DD');
      searchData["toDate"] = moment(newEndDate).format('YYYY-MM-DD');
      searchData["userId"] = isMyOrders ? b2cUserId : "";
      dispatch(getOrdersList(searchData, 0, isAnnexureCorePartChecked));
      dispatch(setPageNumber(null));
    }
  };

  const isAnnexurePartAccess = sessionStorage.getItem('userType') === 'FSE' && customerTypeAccess.includes("dealer") ? true : get(profileDetails, 'data.data.customerInfo.isAnnexurePartAccess', '');
  // const isSearchActive = Boolean(searchText?.trim());
  const [isSearchActive, setIsSearchActive] = useState(false);
  const isSearchActiveRef = React.useRef(false);
  const shouldHideMakePaymentButton = customerAccountType === "Credit" &&
    (customerTierType === "TBL Dealer" || customerTierType === "Dealer") &&
    userType === "Admin";

  useEffect(() => {
    if (orderStatus && orderStatus.data && orderStatus.data.data && orderStatus.data.data.length > 0) {
    } else {
      dispatch(getOrderStatus());
    }
    // if (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.sapCustomerId) {
    //     dispatch(getCreditLimit(sessionStorage.getItem('userType') === 'FSE' ? actualOrder && actualOrder.customerId : sapCustomerId, webApplicationLoginId));
    // }
  }, [profileDetails]) // eslint-disable-line

  React.useEffect(() => {
    const data = getFSECustomerListData?.data || [];
    setAllCustomers(data);
    setCustomerId(data); // default → show all
  }, [getFSECustomerListData]);


  const getTypeFilteredCustomers = useCallback(() => {
    if (!filterByCustomer || filterByCustomer === 'All') {
      return allCustomers;
    }

    const selectedType = getSreCustomerTypeKey(filterByCustomer);
    const filtered = allCustomers.filter(
      (item: any) => item.customerTierType?.toLowerCase() === selectedType
    );

    // eslint-disable-next-line no-console
    console.log('[SRE CustomerType] filterByCustomer:', filterByCustomer, '| selectedType used for match:', selectedType, '| allCustomers:', allCustomers.length, '| matched:', filtered.length);

    return filtered;
  }, [filterByCustomer, allCustomers]);

  React.useEffect(() => {
    setCustomerId(getTypeFilteredCustomers());
  }, [filterByCustomer, allCustomers, getTypeFilteredCustomers]);;


  const getAllCustomerIds = () => {
    let customer_ids: string[] = [];
    if (getFSECustomerListData && getFSECustomerListData.data) {
      customer_ids = getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0 && getFSECustomerListData.data.map((item: any) => item.sapCustomerId);
    }
    return customer_ids;
  }

  const isSubEnquiryMatched = (subEnquiry: any, search: string) => {
    if (!search) return true;

    const text = search.toLowerCase();
    return (
      subEnquiry.orderNumber?.toLowerCase() === text.toLowerCase()
    );
  };


  React.useEffect(() => {
    if (sessionStorage.getItem('userType') === 'FSE') {
      if (!searchText.trim()) {
        setIsSearchActive(false);
        isSearchActiveRef.current = false;
      }
      if (searchText === '' && sessionStorage.getItem('userType') === 'FSE' && getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0) {
        let searchData: any = {};
        if (fseName && fseName !== '') {
          if (fseName === 'All') {
            const webApplicationLoginIds: string[] = fseList && fseList.data && fseList.data.data && fseList.data.data.length > 0 && fseList.data.data.map((item: any) => item.webApplicationLoginId);
            searchData["fseWebApplicationLoginId"] = webApplicationLoginIds;
            setFseWebApplicationLoginId(webApplicationLoginIds);
          } else if (fseName === '' || fseName === 'Cust Only') {
            searchData["fseWebApplicationLoginId"] = [];
            setFseWebApplicationLoginId("");
          } else {
            searchData["fseWebApplicationLoginId"] = [fseName === 'Cust Only' ? "" : fseName];
            setFseWebApplicationLoginId(fseName === 'Cust Only' ? "" : fseName);
          }
        } else {
          searchData["fseWebApplicationLoginId"] = [];
          setFseWebApplicationLoginId("");
        }
        if (selectedCustomerName && selectedCustomerName !== '') {
          searchData["customerId"] = [selectedCustomerName];
        } else if (fseName === '' || fseName === 'Cust Only') {
          searchData["customerId"] = getAllCustomerIds();
        } else {
          searchData["customerId"] = []
        }
      }
    }
    setstatus('');
  }, [getFSECustomerListData]); // eslint-disable-line
  // }, [searchText, startDate, endDate, getFSECustomerListData]); // eslint-disable-line

  // useEffect(() => {
  //   dispatch(getCreditLimit(sapCustomerId, webApplicationLoginId));
  // });

  const handleClick = (event: any, subEnquiry: any, order: any) => {
    setLpoAttachments((subEnquiry && subEnquiry.nowOrderDetails && subEnquiry.nowOrderDetails.lpoAttachments && subEnquiry.nowOrderDetails.lpoAttachments) || (subEnquiry && subEnquiry.backOrderDetails && subEnquiry.backOrderDetails.lpoAttachments && subEnquiry.backOrderDetails.lpoAttachments))
    setQuotationNumber(subEnquiry && subEnquiry.nowOrderDetails && subEnquiry.nowOrderDetails.quotationNumber && subEnquiry.nowOrderDetails.quotationNumber ? subEnquiry && subEnquiry.nowOrderDetails && subEnquiry.nowOrderDetails.quotationNumber && subEnquiry.nowOrderDetails.quotationNumber : subEnquiry && subEnquiry.backOrderDetails && subEnquiry.backOrderDetails.quotationNumber && subEnquiry.backOrderDetails.quotationNumber ? subEnquiry && subEnquiry.backOrderDetails.quotationNumber : "")
    setAnchorEl(event.currentTarget);
    set24hrsStatus(subEnquiry.status);
    setGoodsStatus(subEnquiry.goodsMovementStatus);
    setselectedOrder(subEnquiry);
    setActualOrder(order);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleClickOpen = (str: any) => {
    if (str === "") {
      setOpenDialog(true);
      setPayment(true)
    }
    else if (str !== "") {
      setPayment(false)
      setAnchorEl(null)
    }
    return "called"
  };

  const handleopenCloseSnackbar = (open?: any) => {
    if (open) {
      setAnchorEl(null);
      // Only reload for non-SRE users on snackbar open
      if (sessionStorage.getItem('userType') !== 'sre') {
        loadOrderList();
      }
    }
    setOpenSnackbar(open ? true : false);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearchTextByID("");
  };

  const onSearchCustomerId = (searchText: any) => {
    setSearchTextByID(searchText);
    const baseList = getTypeFilteredCustomers();
    if (searchText.length > 0) {
      const filteredIds = baseList.filter((sapId: any) =>
        sapId.sapCustomerId.toLowerCase().includes(searchText.toLowerCase()) ||
        sapId.name.toLowerCase().includes(searchText.toLowerCase())
      );
      setCustomerId(filteredIds);
    } else {
      setCustomerId(baseList);
    }
  };

  const handleClickSapId = (event: any, sapId: any, name: any) => {
    setSelectedCustomerName(name);
    setSelectedCustomerId(sapId);
  };

  const handleClickForCustomer = (event: React.MouseEvent<HTMLElement>) => {
    setCustomerAnchorEl(event.currentTarget);
  };

  const handleCloseForCustomer = () => {
    setCustomerAnchorEl(null);
    setSearchTextByID("");
  };


  const resetFilters = () => {
    setsearchText('');
    setPage(0);
    const resetStart = orderType === "old" ? ONE_MONTH_BEFORE_DEPLOYMENT : DEPLOYMENT_DATE;
    const resetEnd = orderType === "old" ? DEPLOYMENT_DATE : today;
    setstartDate(resetStart);
    setendDate(resetEnd);
    setFseName(sessionStorage.getItem('webApplicationLoginId'));
    setstatus("");
    setFilterByStatus('');
    setSelectedCustomerId('');
    setSelectedCustomerName('');
    dispatch(setPageNumber(null));
  }

  const resetFiltersForCustomer = () => {
    setsearchText('');
    setCommittedSearch('');
    setPage(0);
    // const resetStart = orderType === "old" ? ONE_MONTH_BEFORE_DEPLOYMENT : DEPLOYMENT_DATE;
    // const resetEnd = orderType === "old" ? DEPLOYMENT_DATE : today;
    const daysDiff = today.diff(DEPLOYMENT_DATE, 'days');
    const resetStart = orderType === "old" ? ONE_MONTH_BEFORE_DEPLOYMENT : (daysDiff <= 31 ? DEPLOYMENT_DATE : today.clone().subtract(31, 'days'));
    const resetEnd = orderType === "old" ? DEPLOYMENT_DATE : today;
    setstartDate(resetStart);
    setendDate(resetEnd);
    setFilterByCustomer(sessionStorage.getItem('userType') === 'sre' ? "All" : '')
    setFseName(sessionStorage.getItem('webApplicationLoginId'));
    setstatus("");
    setIsSearchActive(false);
    isSearchActiveRef.current = false;
    sreLoadedRef.current = false;
    setFilterByStatus('');
    setSelectedCustomerId('');
    setSelectedCustomerName('');
    let searchData: any = { fromDate: moment(resetStart).format('YYYY-MM-DD'), toDate: moment(resetEnd).format('YYYY-MM-DD') };
    searchData["userId"] = isMyOrders ? b2cUserId : "";
    if (sessionStorage.getItem('userType') === 'sre') {
      searchData["customerType"] = 'All';
    }
    // FIX: was using stale `page` (closure value before setPage(0) took effect).
    // If the user reset filters while on page 2/3, the API was queried for that
    // old page under the new filters, causing an out-of-range/empty response —
    // so totalOrderCount (and thus the bottom pagination count) never updated
    // correctly even though the UI page had already reset to 0.
    // dispatch(getOrdersList(searchData, page, isAnnexureCorePartChecked));
    dispatch(getOrdersList(searchData, 0, isAnnexureCorePartChecked));
    dispatch(setPageNumber(null));
    setIsAnnexureCorePartChecked(false);
  }

  function getParameterByName(name: any, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  const getFSECustomerListDataLength = getFSECustomerListData?.data?.length ?? 0;
  const sreLoadedRef = React.useRef(false);

  React.useEffect(() => {
    const userType = sessionStorage.getItem('userType');
    if (userType === 'FSE') {
      if (getFSECustomerListDataLength > 0) {
        loadOrderList();
      }
    } else if (userType === 'sre') {
      if (!sreLoadedRef.current) {
        sreLoadedRef.current = true;
        loadOrderList();
      }
    } else {
      loadOrderList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [b2cUserId, isMyOrders, isAnnexureCorePartChecked, prevPage, getFSECustomerListDataLength]);
  // }, [b2cUserId, searchText, isMyOrders, startDate, endDate, status, prevPage, fseName, getFSECustomerListData, selectedCustomerId, selectedCustomerName])

  const loadOrderList = useCallback((pageNumber?: any) => {
    setPage((prevPage && prevPage !== null) ? prevPage : pageNumber ? pageNumber : 0);
    let newPage = (prevPage && prevPage !== null) ? prevPage : pageNumber ? pageNumber : 0;
    let searchData: any = {};
    const daysDiffNow = today.diff(DEPLOYMENT_DATE, 'days');
    const defaultStart = orderType === "old"
      ? ONE_MONTH_BEFORE_DEPLOYMENT
      : (daysDiffNow <= 31 ? DEPLOYMENT_DATE : today.clone().subtract(31, 'days'));
    const defaultEnd = orderType === "old" ? DEPLOYMENT_DATE : today;

    if (startDate && endDate) { } else if (!searchText) {
      setstartDate(defaultStart);
      setendDate(defaultEnd);
    }

    const isSreUser = sessionStorage.getItem('userType') === 'sre';
    const isDateFilterCleared = !startDate && !endDate;
    const hasSearchTerm = !!(searchText && searchText.trim());

    // SRE-only: when the date-range filter has been cleared and the user is
    // searching by Order Enquiry/Order/Reference No., don't fall back to the
    // usual narrow default window — that was excluding valid matches
    // (New Orders wasn't pinned to the deployment date; Old Orders was
    // limited to a 1-month lookback).
    if (isSreUser && isDateFilterCleared && hasSearchTerm) {
      if (orderType === 'old') {
        searchData["fromDate"] = moment(OLD_ORDERS_SEARCH_START_DATE).format('YYYY-MM-DD');
        searchData["toDate"] = moment(DEPLOYMENT_DATE).format('YYYY-MM-DD');
      } else {
        searchData["fromDate"] = moment(DEPLOYMENT_DATE).format('YYYY-MM-DD');
        searchData["toDate"] = moment(today).format('YYYY-MM-DD');
      }
    } else {
      searchData["fromDate"] = moment(startDate || defaultStart).format('YYYY-MM-DD');
      searchData["toDate"] = moment(endDate || defaultEnd).format('YYYY-MM-DD');
    }

    if (sessionStorage.getItem('userType') === 'FSE') {
      if (sessionStorage.getItem('userType') === 'FSE' && getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0) {
        if (searchText && searchText.trim()) {
          searchData["enquiryNumber"] = searchText.trim();
          searchData["referenceNumber"] = searchText.trim();
          searchData["orderNumber"] = searchText.trim();
        }
        if (status && status !== ALL_STATUS) {
          searchData["status"] = status;
        }
        if (fseName && fseName !== '') {
          if (fseName === 'All') {
            const webApplicationLoginIds: string[] = fseList && fseList.data && fseList.data.data && fseList.data.data.length > 0 && fseList.data.data.map((item: any) => item.webApplicationLoginId);
            searchData["fseWebApplicationLoginId"] = webApplicationLoginIds;
            setFseWebApplicationLoginId(webApplicationLoginIds);
          } else if (fseName === '' || fseName === 'Cust Only') {
            searchData["fseWebApplicationLoginId"] = [];
            setFseWebApplicationLoginId("");
          } else {
            searchData["fseWebApplicationLoginId"] = [fseName === 'Cust Only' ? "" : fseName];
            setFseWebApplicationLoginId(fseName === 'Cust Only' ? "" : fseName);
          }
        } else {
          searchData["fseWebApplicationLoginId"] = [];
          setFseWebApplicationLoginId("");
        }
        if (selectedCustomerName && selectedCustomerName !== '') {
          searchData["customerId"] = [selectedCustomerName];
        } else if (fseName === '' || fseName === 'Cust Only') {
          searchData["customerId"] = getAllCustomerIds();
        } else {
          searchData["customerId"] = []
        }
      }
    } else {
      if (searchText && searchText.trim()) {
        searchData["enquiryNumber"] = searchText.trim();
        searchData["referenceNumber"] = searchText.trim();
        searchData["orderNumber"] = searchText.trim();
      }
      searchData["userId"] = isMyOrders ? b2cUserId : "";
      // NOTE: added `&& !isSreUser` — this legacy block was overwriting the
      // correctly-computed fromDate/toDate above with unformatted values
      // whenever searchText was empty. Left untouched for non-SRE (Customer)
      // flow to avoid any behavior change there.
      if (!hasSearchTerm && !isSreUser) {
        if ((startDate && endDate) || (formattedDate && today)) {
          searchData["fromDate"] = startDate ? startDate : formattedDate;
          searchData["toDate"] = endDate ? endDate : today;
        }
      }
      if (status && status !== ALL_STATUS) {
        searchData["status"] = status;
      }
      if (fseName && fseName !== '') {
        if (fseName === 'All') {
          const webApplicationLoginIds: string[] = fseList && fseList.data && fseList.data.data && fseList.data.data.length > 0 && fseList.data.data.map((item: any) => item.webApplicationLoginId);
          searchData["fseWebApplicationLoginId"] = webApplicationLoginIds;
          setFseWebApplicationLoginId(webApplicationLoginIds);
        } else if (fseName === '' || fseName === 'Cust Only') {
          searchData["fseWebApplicationLoginId"] = [];
          setFseWebApplicationLoginId("");
        } else {
          searchData["fseWebApplicationLoginId"] = [fseName === 'Cust Only' ? "" : fseName];
          setFseWebApplicationLoginId(fseName === 'Cust Only' ? "" : fseName);
        }
      } else {
        searchData["fseWebApplicationLoginId"] = [];
        setFseWebApplicationLoginId("");
      }
      if (selectedCustomerName && selectedCustomerName !== '') {
        searchData["customerId"] = [selectedCustomerName];
      } else if (fseName === '' || fseName === 'Cust Only') {
        searchData["customerId"] = getAllCustomerIds();
      } else {
        searchData["customerId"] = []
      }
      if (isSreUser) {
        // NOTE: was `filterByCustomer === 'TPC Dealer' ? 'tpcdealer' : filterByCustomer`
        // — only special-cased one label, so "TBL Dealer", "Fleet", etc. went
        // to the backend unmapped and the filter was effectively ignored.
        searchData["customerType"] = getSreCustomerTypeKey(filterByCustomer);
        if (selectedCustomerName && selectedCustomerName !== '') {
          searchData["customerId"] = [selectedCustomerName];
        } else {
          searchData["customerId"] = []
        }
      }
    }
    dispatch(getOrdersList(searchData, newPage, isAnnexureCorePartChecked));
    dispatch(setPageNumber(null));
    setLoading(false);
  }, [b2cUserId, dispatch, searchText, isMyOrders, isAnnexureCorePartChecked, startDate, endDate, status, prevPage, fseName, getFSECustomerListData, selectedCustomerId, selectedCustomerName, orderType, filterByCustomer]);

  const loadOrderListOnClickOfSearch = useCallback((pageNumber?: any, e?: any) => {
    setPage((prevPage && prevPage !== null) ? prevPage : pageNumber ? pageNumber : 0);
    let newPage = (prevPage && prevPage !== null) ? prevPage : pageNumber ? pageNumber : 0;
    let searchData: any = {};
    if (sessionStorage.getItem('userType') === 'FSE') {
      if (sessionStorage.getItem('userType') === 'FSE' && getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0) {
        if (e.target.value && e.target.value.trim()) {
          searchData["enquiryNumber"] = e.target.value.trim();
          searchData["referenceNumber"] = e.target.value.trim();
          searchData["orderNumber"] = e.target.value.trim();
        }
        if (startDate && endDate) {
          searchData["fromDate"] = moment(startDate).format('YYYY-MM-DD');
          searchData["toDate"] = moment(endDate).format('YYYY-MM-DD');
        }
        if (status && status !== ALL_STATUS) {
          searchData["status"] = status;
        }
        if (fseName && fseName !== '') {
          if (fseName === 'All') {
            const webApplicationLoginIds: string[] = fseList && fseList.data && fseList.data.data && fseList.data.data.length > 0 && fseList.data.data.map((item: any) => item.webApplicationLoginId);
            searchData["fseWebApplicationLoginId"] = webApplicationLoginIds;
            setFseWebApplicationLoginId(webApplicationLoginIds);
          } else if (fseName === '' || fseName === 'Cust Only') {
            searchData["fseWebApplicationLoginId"] = [];
            setFseWebApplicationLoginId("");
          } else {
            searchData["fseWebApplicationLoginId"] = [fseName === 'Cust Only' ? "" : fseName];
            setFseWebApplicationLoginId(fseName === 'Cust Only' ? "" : fseName);
          }
        } else {
          searchData["fseWebApplicationLoginId"] = [];
          setFseWebApplicationLoginId("");
        }
        if (selectedCustomerName && selectedCustomerName !== '') {
          searchData["customerId"] = [selectedCustomerName];
        } else if (fseName === '' || fseName === 'Cust Only') {
          searchData["customerId"] = getAllCustomerIds();
        } else {
          searchData["customerId"] = []
        }
      }
    } else {
      if (e.target.value && e.target.value.trim()) {
        searchData["enquiryNumber"] = e.target.value.trim();
        searchData["referenceNumber"] = e.target.value.trim();
        searchData["orderNumber"] = e.target.value.trim();
      }
      searchData["userId"] = isMyOrders ? b2cUserId : "";
      if (startDate && endDate) {
        searchData["fromDate"] = moment(startDate).format('YYYY-MM-DD');
        searchData["toDate"] = moment(endDate).format('YYYY-MM-DD');
      }
      if (status && status !== ALL_STATUS) {
        searchData["status"] = status;
      }
    }
    // dispatch(getOrdersList(searchData, deliveryType, newPage));
    setLoading(true);
    // dispatch(getOrdersList(searchData, newPage));
    dispatch(setPageNumber(null));
    setLoading(false);
  }, [b2cUserId, dispatch, searchText, isMyOrders, isAnnexureCorePartChecked, startDate, endDate, status, prevPage, fseName, getFSECustomerListData, selectedCustomerId, selectedCustomerName]);


  const getInvoiceDetails = (orderDetails: any) => {
    const data = {
      orderNumber: orderDetails.orderNumber,
      enquiryNumber: orderDetails.enquiryNumber,
      webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
      make: orderDetails.make
    }
    if (data.orderNumber && data.enquiryNumber && data.webApplicationLoginId && data.make) {
      dispatch(getInvoice(data));
    }
  }

  React.useEffect(() => {
    if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
      dispatch(getFSECustomerList());
      if (sessionStorage.getItem('userType') !== 'sre') {
        if (fseList && fseList.data && fseList.data.data && fseList.data.data.length > 0) {
        } else {
          dispatch(getFSEList());
        }
      }
    }
  }, [])

  // React.useEffect(() => {
  //   if (searchText === '') {
  //     loadOrderList()
  //   }
  // }, [isMyOrders]); //eslint-disable-line

  // }, [searchText, startDate, endDate, isMyOrders]);

  const resetInvoiceValues = useCallback(() => {
    dispatch(resetInvoice());
  }, [dispatch]);

  useEffect(() => {
    if (!openSnackbar) resetInvoiceValues();
  }, [openSnackbar, resetInvoiceValues]);

  useEffect(() => {
    if (invoice && invoice.data && invoice.data.data && invoice.data.data.invoiceUrl) {
      downloadUrl(invoice.data.data.invoiceUrl);
      handleopenCloseSnackbar(true);
    }
    if (invoice && invoice.err && invoice.err.statusText && invoice.err.statusText.data && invoice.err.statusText.data.error) {
      handleopenCloseSnackbar(true);
    }
  }, [invoice]);

  const downloadUrl = (url: any) => {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleChangePage = (event: unknown, newPage: number) => {
    dispatch(setPageNumber(null));
    loadOrderList(newPage)
    setPage(newPage);
  };

  const handleopenCloseReturnRequest = (open?: any) => {
    setOpenReturnRequest(open ? true : false);
  };

  const handleopenCloseReturnRequestSnackbar = (open?: any) => {
    setOpenReturnRequestSnackbar(open ? true : false);
  };

  const handleCloseViewQuotation = () => {
    setOpenViewQuotation(false);
  }

  const updateLPO = () => {
    setOpenUploadLpo(true);
    isUpdateLPO(true);
  }

  const handleCloseViewLPO = () => {
    setOpenViewLPO(false);
  }

  const handleViewQuotation = async () => {
    let data: any = await dispatch(downloadQuotation(enquiryNumber, quotationNumber, brandId))
    if (data && data.error) {
      showErrorMessage(data && data.error)
      setOpenErrorSnackbar(true);
      setTimeout(() => {
        setOpenErrorSnackbar(false);
      }, 2000)
      setOpenViewQuotation(false)
    } else {
      // window.open(data && data.data)
      if (data) {
        setOpenViewQuotation(true)
        setViewQuotationUrl(data)
      }
    }
  }

  const handleViewLPO = async (orderNo: any, quotationNo: any) => {
    if (quotationNo) {
      let data: any = await dispatch(viewLPO(webApplicationLoginId, enquiryNumber, sapCustomerId, quotationNo, ""))
      if (data && data.statusText && data.statusText.data.success === false) {
        showErrorMessage(data && data.statusText && data.statusText.data.message && data.statusText.data.message.message)
        setOpenErrorSnackbar(true);
        setTimeout(() => {
          setOpenErrorSnackbar(false);
        }, 2000)
        setOpenViewLPO(false)
      } else {
        if (lpoAttachments && lpoAttachments.length > 0) {
          const fileName = lpoAttachments[0] && lpoAttachments[0].url.substring(lpoAttachments[0].url.lastIndexOf('/') + 1);
          const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
          setFileExtension(fileExtension.toLowerCase())
          if (fileExtension === 'pdf') {
            setViewQuotationUrl(data && typeof data === 'string' ? data : lpoAttachments[0].url);
            setOpenViewLPO(true);
            // fetch(lpoAttachments[0].url ? lpoAttachments[0].url : data).then(resp => resp.arrayBuffer()).then(resp => {
            //   const file = new Blob([resp], { type: 'application/pdf' });
            //   const fileURL = URL.createObjectURL(file);
            //   setViewQuotationUrl(fileURL)
            //   if (fileURL) {
            //     setOpenViewLPO(true)
            //   }
            // });
          } else if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg') {
            setViewQuotationUrl(lpoAttachments[0].url);
            if (lpoAttachments[0].url) {
              setOpenViewLPO(true)
            }
          }
        }
      }
    } else {
      let data: any = await dispatch(viewLPO(webApplicationLoginId, enquiryNumber, sessionStorage.getItem('userType') === 'FSE' ? actualOrder && actualOrder.customerId : sapCustomerId, "", orderNo))
      if (data && data.error) {
        showErrorMessage(data && data.error)
        setOpenErrorSnackbar(true);
        setTimeout(() => {
          setOpenErrorSnackbar(false);
        }, 2000)
        setOpenViewLPO(false)
      } else {
        // window.open(data && data.data)
        // if (data) {
        //   setOpenViewLPO(true)
        //   setViewQuotationUrl(data)
        // }
        if (lpoAttachments && lpoAttachments.length > 0) {
          const fileName = lpoAttachments[0] && lpoAttachments[0].url.substring(lpoAttachments[0].url.lastIndexOf('/') + 1);
          const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
          setFileExtension(fileExtension.toLowerCase())
          if (fileExtension === 'pdf') {
            setViewQuotationUrl(data && typeof data === 'string' ? data : lpoAttachments[0].url);
            setOpenViewLPO(true);
            // fetch(lpoAttachments[0].url ? lpoAttachments[0].url : data).then(resp => resp.arrayBuffer()).then(resp => {
            //   const file = new Blob([resp], { type: 'application/pdf' });
            //   const fileURL = URL.createObjectURL(file);
            //   setViewQuotationUrl(fileURL)
            //   if (fileURL) {
            //     setOpenViewLPO(true)
            //   }
            // });
          } else if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg') {
            setViewQuotationUrl(lpoAttachments[0].url || data);
            if (lpoAttachments[0].url) {
              setOpenViewLPO(true)
            }
          }
        }
      }
    }
  }

  // function getDisplayName(subEnquiry: any) {
  //   const customerType = subEnquiry.customerType?.toLowerCase();
  //   const tierType = customerTierType?.toLowerCase();
  //   const makeBrand = getNewBrand(subEnquiry.make?.toString());
  //   const originalMake = subEnquiry.make?.toString().toLowerCase();

  //   // Check 1: TPC Dealer or Workshop
  //   if (
  //     tierType === 'tpcdealer' ||
  //     customerType === 'tpcdealer' ||
  //     tierType === 'workshop' ||
  //     customerType === 'workshop'
  //   ) {
  //     return 'Tradepoint';
  //   }

  //   // Check 2: Fleet/Government/Int. Business - MUST BE CHECKED BEFORE DEALER
  //   const isFleetOrGovernment =
  //     tierType === 'fleet' ||
  //     tierType === 'government' ||
  //     tierType === 'int. business' ||
  //     customerType === 'fleet' ||
  //     customerType === 'government' ||
  //     customerType === 'int. business';

  //   if (isFleetOrGovernment) {
  //     // For Fleet/Government, if brand is OES, Tradepoint, or ANY ALAC variant, return just "ALAC"
  //     if (
  //       originalMake === 'oes' ||
  //       originalMake === 'tradepoint' ||
  //       makeBrand === 'Tradepoint' ||
  //       makeBrand === 'ALAC' ||
  //       makeBrand === 'ALAC Tyres & Batteries' ||
  //       makeBrand === 'ALAC AfterMarket Parts' ||
  //       subEnquiry.displayName === 'ALAC' ||
  //       subEnquiry.displayName === 'ALAC Tyres & Batteries' ||
  //       subEnquiry.displayName === 'ALAC AfterMarket Parts' ||
  //       subEnquiry.materialGroupCode === 'ALPOE' ||
  //       subEnquiry.materialGroupCode === 'AMPTB'
  //     ) {
  //       return 'ALAC';
  //     }
  //     return makeBrand;
  //   }

  //   // Check 3: Is Dealer (TBL Dealer)
  //   const isDealer =
  //     tierType === 'tbl dealer' ||
  //     customerType === 'tbl dealer' ||
  //     tierType === 'dealer' ||
  //     customerType === 'dealer';

  //   if (isDealer) {
  //     if (subEnquiry.displayName) {
  //       return subEnquiry.displayName === 'BYD' ? getNewBrand(subEnquiry.make?.toString()) : subEnquiry.displayName;
  //     }

  //     if (subEnquiry.materialGroupCode === 'ALPOE') {
  //       return 'ALAC AfterMarket Parts';
  //     }

  //     if (subEnquiry.materialGroupCode === 'AMPTB') {
  //       return 'ALAC Tyres & Batteries';
  //     }
  //   }

  //   // Check 4: Tradepoint brand for non-workshop customers
  //   if (
  //     makeBrand === 'Tradepoint' &&
  //     tierType !== 'workshop' &&
  //     customerType !== 'workshop' &&
  //     customerType !== 'tpcdealer'
  //   ) {
  //     return 'ALAC';
  //   }

  //   // Default return
  //   return makeBrand;
  // }

  function getDisplayName(subEnquiry: any) {
    if (orderType === "new") {
      const displayLabel = getDisplayNameBySalesOffice(
        subEnquiry?.customerType || "",
        subEnquiry?.salesOffice || ""
      );
      return displayLabel === "Others (Tyres / Batteries / Lubes / IAM)" ? (
        <>
          <span className="fw-bold fs-5">Others</span>{" "}
          <span className="fs-6 text-muted">
            (Tyres / Batteries / Lubes / IAM)
          </span>
        </>
      ) : (
        displayLabel || ""
      );
    } else {
      const customerType = subEnquiry.customerType?.toLowerCase();
      const tierType = customerTierType?.toLowerCase();
      const makeBrand = getNewBrand(subEnquiry.make?.toString());
      const originalMake = subEnquiry.make?.toString().toLowerCase();
      if (
        tierType === 'tpcdealer' || customerType === 'tpcdealer' ||
        tierType === 'workshop' || customerType === 'workshop'
      ) {
        return 'Tradepoint';
      }
      const isFleetOrGovernment =
        tierType === 'fleet' || tierType === 'government' || tierType === 'int. business' ||
        customerType === 'fleet' || customerType === 'government' || customerType === 'int. business';
      if (isFleetOrGovernment) {
        if (
          originalMake === 'oes' || originalMake === 'tradepoint' ||
          makeBrand === 'Tradepoint' || makeBrand === 'ALAC' ||
          makeBrand === 'ALAC Tyres & Batteries' || makeBrand === 'ALAC AfterMarket Parts' ||
          subEnquiry.displayName === 'ALAC' || subEnquiry.displayName === 'ALAC Tyres & Batteries' ||
          subEnquiry.displayName === 'ALAC AfterMarket Parts' ||
          subEnquiry.materialGroupCode === 'ALPOE' || subEnquiry.materialGroupCode === 'AMPTB'
        ) {
          return 'ALAC';
        }
        return makeBrand;
      }
      const isDealer =
        tierType === 'tbl dealer' || customerType === 'tbl dealer' ||
        tierType === 'dealer' || customerType === 'dealer';
      if (isDealer) {
        if (subEnquiry.displayName) {
          return subEnquiry.displayName === 'BYD' ? getNewBrand(subEnquiry.make?.toString()) : subEnquiry.displayName;
        }
        if (subEnquiry.materialGroupCode === 'ALPOE') return 'ALAC AfterMarket Parts';
        if (subEnquiry.materialGroupCode === 'AMPTB') return 'ALAC Tyres & Batteries';
      }
      if (
        makeBrand === 'Tradepoint' && tierType !== 'workshop' &&
        customerType !== 'workshop' && customerType !== 'tpcdealer'
      ) {
        return 'ALAC';
      }
      return makeBrand;
    }
  }

  const handleUploadLpo = async () => {
    loadOrderList();
    handleClose();
    if (isLPOUpdate) {
      await handleViewLPO(orderNumber, quotationNumber);
      setOpenViewLPO(false);
      loadOrderList();
    }
    setOpenUploadLpo(false);
    isUpdateLPO(false);
  }

  const { data: orders } = orderList || {};

  return (
    <Fragment>
      <Snackbar
        open={openSnackbar}
        type={openErrorSnackbar ? 'error' : ''}
        handleopenClose={() => {
          handleopenCloseSnackbar(false)
        }} message={successMessage} />
      {loading && (<FullscreenLoader />)}
      {dataOrderRedux && dataOrderRedux.orderList && dataOrderRedux.orderList.loading && <FullscreenLoader />}
      {((orderList && orderList.loading) || (deliveryList && deliveryList.loading)) && <FullscreenLoader />}
      {payment === false ?
        <>
          <div className="d-flex align-items-center">
            <h2 className="page-title">
              Order History
            </h2>
            <div className="ml-auto d-flex align-items-center">
              <ToggleButtonGroup
                value={orderType}
                exclusive
                onChange={handleOrderType}
                aria-label="order type"
                size="small"
                className={classes.toggleGroup}
              >
                <ToggleButton value="new" aria-label="new orders" className={`${classes.toggleBtn} ${classes.toggleBtnLeft}`}>
                  New Orders
                </ToggleButton>
                <ToggleButton value="old" aria-label="old orders" className={`${classes.toggleBtn} ${classes.toggleBtnRight}`}>
                  Old Orders
                </ToggleButton>
              </ToggleButtonGroup>
              <AnnouncementIcon />
              <NotificationIcon />
            </div>
          </div>
          {/* <div className="row mt-4"> */}
          <ReturnRequestSnackbar
            open={openReturnRequestSnackbar}
            handleopenClose={() => {
              handleopenCloseReturnRequestSnackbar(false)
            }}
          />
          {invoice && invoice.data && invoice.data.data && invoice.data.data.invoiceUrl && (
            <Snackbar
              open={openSnackbar}
              message='Invoice Downloaded Successfully'
              handleopenClose={() => {
                handleopenCloseSnackbar(false)
              }} />
          )}
          {invoice && invoice.err && invoice.err.statusText && invoice.err.statusText.data && invoice.err.statusText.data.error && (
            <Snackbar
              open={openSnackbar}
              type="error"
              message={invoice.err.statusText.data.error ? invoice.err.statusText.data.message.message : 'Invoice Request Failed'}
              handleopenClose={() => {
                handleopenCloseSnackbar(false)
              }} />
          )}
          {deliveryList && deliveryList.err && deliveryList.err.statusText && deliveryList.err.statusText.data && deliveryList.err.statusText.data.message && deliveryList.err.statusText.data.message.status && deliveryList.err.statusText.data.message.status === "E" && (
            <Snackbar
              open={openSnackbar}
              type="error"
              message={deliveryList.err.statusText.data.message.message ? deliveryList.err.statusText.data.message.message : 'There was a problem fetching the delivery list'}
              handleopenClose={() => {
                handleopenCloseSnackbar(false)
              }} />
          )}
          {/* <ReturnRequestDialog
            selectedOrder={selectedOrder}
            open={openReturnRequest}
            markReturned={setIsReturned}
            handleopenClose={(data: any) => {
              if (data) {
                //return api call here
                handleopenCloseReturnRequestSnackbar(true)
              }
              handleopenCloseReturnRequest(false)
            }}
          /> */}
          {/* </div> */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="cardCommon p-3">

                <div className="d-flex align-items-center mb-3">
                  <h5 className="page-sub-title mb-0">Search Orders</h5>
                </div>

                {/* ===== FIRST ROW ===== */}
                <div className="row align-items-center">
                  {/* Search Field */}
                  <div className="col-4 col-sm-6 col-md-4 col-lg-4 mb-2">
                    <TextField
                      value={searchText}
                      onChange={(e) => {
                        const value = e.target.value;
                        setsearchText(value);
                        if (value === "") {
                          setCommittedSearch("");
                          setOpen(-1);
                          setIsSearchActive(false);
                          isSearchActiveRef.current = false;
                          loadOrderList(0);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setCommittedSearch(searchText);
                          setIsSearchActive(true);
                          isSearchActiveRef.current = true;
                          if (sessionStorage.getItem('userType') === 'sre') {
                            // A stale redux "prevPage" was overriding the
                            // explicit page-0 reset below, making pagination
                            // look broken after a new filtered search.
                            dispatch(setPageNumber(null));
                            setPage(0);
                          }
                          loadOrderList(0);
                        }
                      }}
                      size="small"
                      fullWidth
                      className="common-input-font-size commonRoundedInputs"
                      label="Search by Order Enquiry No/Order No/Reference No"
                      variant="outlined"
                    />
                  </div>

                  {/* Date Picker */}
                  <div className="col-4 col-sm-6 col-md-4 col-lg-4 mb-2 date-picker-50">
                    <Tooltip title="Maximum 31 days data can be tracked." placement="top">
                      <div className="date-picker-50">
                        <DatePicker
                          startDate={startDate}
                          endDate={endDate}
                          setstartDate={setstartDate}
                          setendDate={setendDate}
                          isEnableOnlyThirtyDays={true}
                          minDate={orderType === "old" ? undefined : DEPLOYMENT_DATE.toDate()}
                          maxDate={orderType === "old" ? DEPLOYMENT_DATE.toDate() : today.toDate()}
                          onChange={(start: any, end: any) => {
                            if (orderType === "old") {
                              const clampedStart =
                                start && moment(start).isAfter(DEPLOYMENT_DATE, "day")
                                  ? DEPLOYMENT_DATE
                                  : start;

                              const clampedEnd =
                                end && moment(end).isAfter(DEPLOYMENT_DATE, "day")
                                  ? DEPLOYMENT_DATE
                                  : end;

                              setstartDate(clampedStart);
                              setendDate(clampedEnd);
                            } else {
                              const clampedStart = start && moment(start).isBefore(DEPLOYMENT_DATE) ? DEPLOYMENT_DATE : start;
                              setstartDate(clampedStart);
                              setendDate(end);
                            }
                          }}
                        />
                      </div>
                    </Tooltip>
                  </div>

                  {/* Status */}
                  <div className={(sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre')
                    ? "col-4 col-sm-6 col-md-4 col-lg-4 mb-2"
                    : "col-2 col-sm-2 col-md-2 col-lg-2 mb-2"}>
                    <FormControl size="small" variant="outlined" className="rounded-input-dealer w-100" fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={status}
                        onChange={(e) => setstatus(e.target.value)}
                        label="Status"
                      >
                        <MenuItem value={ALL_STATUS}>All</MenuItem>
                        {orderStatus?.data?.data?.map((status: any) => (
                          <MenuItem key={status} value={status}>{status}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  {/* Search Button for Non-FSE */}
                  {(sessionStorage.getItem('userType') !== 'FSE' &&
                    sessionStorage.getItem('userType') !== 'sre') && (
                      <div className="col-2 col-sm-2 col-md-2 col-lg-2 mb-2 border-search">
                        <Button
                          size="small"
                          variant="contained"
                          className="addOrderEnqButton"
                          color="primary"
                          onClick={() => {
                            setCommittedSearch(searchText);
                            setIsSearchActive(true);
                            isSearchActiveRef.current = true;
                            if (sessionStorage.getItem('userType') === 'sre') {
                              dispatch(setPageNumber(null));
                              setPage(0);
                              loadOrderList(0);
                            } else {
                              loadOrderList();
                            }
                          }}
                        >
                          Search
                        </Button>
                      </div>
                    )}
                </div>

                {/* ===== SECOND ROW (Customer Login) ===== */}
                {(sessionStorage.getItem('userType') !== 'FSE' &&
                  sessionStorage.getItem('userType') !== 'sre') && (

                    <div className="row mt-3 align-items-center">

                      <div className="col-2 d-flex align-items-center">
                        <Checkbox
                          checked={isMyOrders}
                          onChange={() => {
                            setPage(0);
                            setisMyOrders(!isMyOrders);
                          }}
                        />
                        <span className="myOrders mb-2">My Orders</span>
                      </div>

                      {(isAnnexurePartAccess &&
                        ((customerTierType && customerTierType === 'Dealer')
                          || customerTypeAccess.includes("dealer"))) && (
                          <div className="col-3 d-flex align-items-center">
                            <Checkbox
                              checked={isAnnexureCorePartChecked}
                              onChange={() => {
                                setPage(0);
                                setIsAnnexureCorePartChecked(!isAnnexureCorePartChecked);
                              }}
                            />
                            <span className="myOrders mb-2">
                              Annexure/Core Product Order
                            </span>
                          </div>
                        )}

                      <div className="col-3 ml-auto text-right">
                        <Button
                          variant="contained"
                          className="cancel-button mr-2"
                          onClick={() => {
                            setLoading(true);
                            resetFiltersForCustomer();
                            setLoading(false);
                          }}
                        >
                          Reset Filters
                        </Button>
                      </div>

                    </div>
                  )}

                {/* ===== SECOND ROW (FSE / SRE Login) ===== */}
                {(sessionStorage.getItem('userType') === 'FSE' ||
                  sessionStorage.getItem('userType') === 'sre') && (

                    <div className="row mt-3 align-items-center">

                      {/* SRE → Filter By Customer Type */}
                      {sessionStorage.getItem('userType') === 'sre' && (
                        <div className="col-3 mb-2">
                          <TextField
                            select
                            label="Filter By CustomerType"
                            variant="outlined"
                            className="commonRoundedInputs bd-highlight"
                            size="small"
                            fullWidth
                            value={filterByCustomer}
                            onChange={(e: any) => {
                              setSelectedCustomerId('');
                              setSelectedCustomerName('');
                              setFilterByCustomer(e.target.value);
                            }}
                          >
                            {getCustomerFilterOptions('sreCustomerList')}
                          </TextField>
                        </div>
                      )}

                      {/* FSE + SRE → Filter By Customer */}
                      <div className="col-3 mb-2">
                        <TextField
                          id="customerId"
                          variant="outlined"
                          size="small"
                          onClick={handleClickForCustomer}
                          value={selectedCustomerId}
                          label="Filter By Customer"
                          aria-controls="customized-menu"
                          className="commonRoundedInputs w-100"
                          aria-haspopup="true"
                          placeholder="Filter By Customer"
                        >
                        </TextField>
                        <StyledMenu
                          id="customized-menu"
                          anchorEl={customerAnchorEl}
                          keepMounted
                          className="dealer-custom-dropdown"
                          open={Boolean(customerAnchorEl)}
                          onClose={handleCloseForCustomer}
                        >
                          <div>
                            <div className="mt-2">
                              <div className="searchDealer">
                                <IconButton
                                  edge="start"
                                  className="ml-2"
                                  disabled
                                >
                                  <SearchIcon fontSize="inherit" />
                                </IconButton>
                                <TextField value={searchTextByID} onChange={(e) => {
                                  onSearchCustomerId(e.target.value)
                                }}
                                  size="small" className="ml-n2 mt-1" placeholder="Search Customer(s)" variant="outlined" />
                              </div>
                            </div>
                            {customerId && customerId.length > 0 && customerId.map((sapId: any, i: any) => (
                              <Grid key={i} container className="border-bottom">
                                <MenuItem key={i} value={sapId.sapCustomerId}>
                                  <ListItemText primary={sapId.sapCustomerId} onClick={(event) => { handleClickSapId(event, sapId.name, sapId.sapCustomerId); handleCloseForCustomer() }} /><p className="px-5" onClick={(event) => { handleClickSapId(event, sapId.name, sapId.sapCustomerId); handleCloseForCustomer() }}> {" "} {" "} {sapId.name}</p>
                                </MenuItem>
                              </Grid>
                            ))}
                            {customerId && customerId.length === 0 && (
                              <Grid container >
                                <div className="d-flex justify-content-center text-center mx-auto">No Customers found.</div>
                              </Grid>
                            )}
                          </div>
                        </StyledMenu>
                      </div>

                      {/* Only FSE → Filter By FSE */}
                      {sessionStorage.getItem('userType') !== 'sre' && (
                        <div className="col-3 mb-2">
                          <FormControl size="small" variant="outlined" className="rounded-input-dealer w-100" fullWidth>
                            <InputLabel>Filter By FSE</InputLabel>
                            <Select
                              value={fseName}
                              onChange={(e) => setFseName(e.target.value)}
                              label="Filter By FSE"
                            >
                              <MenuItem value={"All"}>
                                {sessionStorage.getItem('userType') === 'FSE'
                                  ? "All FSE"
                                  : "All"}
                              </MenuItem>

                              {fseList?.data?.data?.map((fse: any) => (
                                <MenuItem
                                  key={fse.name}
                                  value={fse.webApplicationLoginId}
                                >
                                  {fse.name} - {fse.webApplicationLoginId}
                                </MenuItem>
                              ))}

                              <MenuItem
                                value={
                                  sessionStorage.getItem('userType') === 'FSE'
                                    ? "Cust Only"
                                    : ""
                                }
                              >
                                {sessionStorage.getItem('userType') === 'FSE'
                                  ? "Cust Only"
                                  : "None"}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      )}

                      {/* Annexure Checkbox */}
                      {(isAnnexurePartAccess &&
                        ((customerTierType && customerTierType === 'Dealer') ||
                          customerTypeAccess.includes("dealer"))) && (
                          <div className="col-3 d-flex align-items-center mb-2">
                            <Checkbox
                              checked={isAnnexureCorePartChecked}
                              onChange={() =>
                                setIsAnnexureCorePartChecked(!isAnnexureCorePartChecked)
                              }
                            />
                            <span className="myOrders mb-2">
                              Annexure/Core Product
                            </span>
                          </div>
                        )}

                      {/* Buttons */}
                      <div className="col-3 ml-auto text-right mb-2">
                        <Button
                          variant="contained"
                          className="cancel-button mr-2"
                          onClick={resetFiltersForCustomer}
                        >
                          Reset Filters
                        </Button>
                        <Button
                          size="small"
                          variant="contained"
                          className="addOrderEnqButton"
                          color="primary"
                          onClick={() => {
                            setCommittedSearch(searchText);
                            setIsSearchActive(true);
                            isSearchActiveRef.current = true;
                            loadOrderList();
                          }}
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="d-flex align-items-center">
                <h5 className="page-sub-title">List of Orders</h5>
                <div className="legendItem ml-auto">
                  {/* <span className="orangedot"></span>
                  <span className="legendItemLabel mr-4">Return Created</span> */}
                  <span className="dot"></span>
                  <span className="legendItemLabel px-1">Back Order</span>
                </div>
                {(isAnnexurePartAccess && (customerTierType && customerTierType === 'Dealer')) ?
                  <div className="px-3">
                    <span className="annexurePart mt-1"></span>
                    <span className="legendItemLabel mr-4 ml-2 mt-0">Annexure/Core Product</span>
                  </div>
                  : ""}
                {sessionStorage.getItem('userType') === 'FSE' && customerTypeAccess.includes("dealer") && (
                  <div className="px-3">
                    <span className="annexurePart mt-1"></span>
                    <span className="legendItemLabel mr-4 ml-2 mt-0">Annexure/Core Product</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-12 col-lg-12 col-md-12 col-sm-12">
              <div className="cardCommon mh-300p">
                <TableContainer>
                  <Table aria-label="table" >
                    <TableHead className="w-100">
                      <TableRow>
                        <TableCell className={classes.tableHeadSmall}></TableCell>
                        <TableCell className={classes.tableHeadForOrderNo}>Order Enquiry No.</TableCell>
                        <TableCell className={classes.tableHead}>Reference No.</TableCell>
                        <TableCell className={classes.tableHead}>Brand</TableCell>
                        <TableCell className={classes.tableHead}>
                          <h6 className="totalHead">Total Amount</h6>
                          <div className="text-muted font-10 font-weight-600">(incl. of Vat)</div>
                        </TableCell>
                        <TableCell className={classes.tableHead}>Created By</TableCell>
                        <TableCell className={classes.tableHead}>Created On</TableCell>
                        <TableCell className={classes.tableHead}>Status</TableCell>
                        <TableCell className={classes.tableHead}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {!isEmpty(orders) && orders.map((order: any, index: any) => {
                        // const { order } = props;
                        const { subEnquiries } = order || {};
                        const updatedSubEnquiries = subEnquiries?.map((item: any) => ({
                          ...item,
                          orderNumber: item.isAirOrder ? item.backOrderNumber : item.orderNumber
                        }));
                        let matchedSubEnquiries = committedSearch && committedSearch !== '' && (isSearchActive || isSearchActiveRef.current)
                          ? updatedSubEnquiries?.filter((se: any) =>
                            isSubEnquiryMatched(se, committedSearch)
                          )
                          : subEnquiries;
                        let shouldAutoExpand = false;
                        if (matchedSubEnquiries?.length > 0 && committedSearch && committedSearch !== '') {
                          shouldAutoExpand = (isSearchActive || isSearchActiveRef.current && matchedSubEnquiries?.length > 0) || (orders && orders?.length === 1);
                        } else {
                          matchedSubEnquiries = subEnquiries;
                          shouldAutoExpand = false;
                        }

                        const showViewEnquiry = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.VIEW_ENQUIRY_DETAILS);
                        return (
                          <React.Fragment>
                            <TableRow key={order.masterId} hover role="checkbox" tabIndex={-1}
                              onClick={() => {
                                const isCurrentlyOpen = open === index + 1 ? true : open === -(index + 2) ? false : shouldAutoExpand;
                                setOpen(isCurrentlyOpen ? -(index + 2) : index + 1);
                              }}
                              className="hover-pointer" >
                              <TableCell className={classes.bodyContentSmall}>
                                <IconButton aria-label="expand row" size="small" className={classes.collapseIcon}>
                                  {(open === index + 1 ? true : open === -(index + 2) ? false : shouldAutoExpand) ? <RemoveIcon fontSize="inherit" /> : <Add fontSize="inherit" />}
                                </IconButton>
                              </TableCell>
                              <TableCell className={classes.bodyContent}>
                                <Box display="flex" alignItems="center">
                                  <span className={clsx(classes.iconSlot, {
                                    [classes.annexurePart]: isAnnexurePartAccess &&
                                      order.isAnnexureEnquiry === true &&
                                      (customerTierType === 'Dealer' || customerTypeAccess.includes("dealer"))
                                  })} />
                                  {""}
                                  <span>{order.masterId}</span>
                                </Box>
                              </TableCell>
                              <TableCell className={classes.bodyContent}>{order.masterReferenceNumber}</TableCell>
                              {/* <TableCell align="left" className={classes.bodyContent}>
                                {
                                  // ((customerTierType === 'TBL Dealer' || subEnquiries[0]?.customerType?.toLowerCase() === 'tbl dealer') && order.materialGroupCode === "ALPOE" && order.brands && Array.isArray(order.brands) && order.brands.length === 1) ? 'ALAC Parts' : ((customerTierType === 'TBL Dealer' || subEnquiries[0]?.customerType?.toLowerCase() === 'tbl dealer') && order.materialGroupCode === "AMPTB" && order.brands && Array.isArray(order.brands) && order.brands.length === 1) ? 'ALAC Tyres & Batteries' : ((customerTierType === 'TBL Dealer' || subEnquiries[0]?.customerType?.toLowerCase() === 'tbl dealer') && order.brands && Array.isArray(order.brands) && order.brands.length === 2) ? 'ALAC Tyres & Batteries, ALAC Parts' :
                                  order.brands && Array.isArray(order.brands) && customerTierType && (customerTierType.toLowerCase() !== 'workshop' || subEnquiries[0]?.customerType?.toLowerCase() !== 'workshop') && subEnquiries && subEnquiries[0]?.customerType !== 'tpcdealer' ? order.brands.map((brand: any) => brand === "Tradepoint" ? "ALAC" : brand).join(', ') : subEnquiries[0]?.customerType === 'tpcdealer' || customerTierType.toLowerCase() === 'workshop' || subEnquiries[0]?.customerType?.toLowerCase() === 'workshop' ? "Tradepoint" : order.brands.toString()}
                                {/* {order.brands && Array.isArray(order.brands) && order.brands.toString()}
                                {(() => {

                                  const tierType = customerTierType?.toLowerCase();
                                  const subEnqType = subEnquiries[0]?.customerType?.toLowerCase();

                                   Check for tpcdealer or workshop first
                                  if (subEnqType === 'tpcdealer' || tierType === 'tpcdealer' || tierType === 'workshop' || subEnqType === 'workshop') {
                                    return "Tradepoint";
                                  }

                                   Check for Fleet, Government, Int. Business
                                  if (tierType === 'fleet' || tierType === 'government' || tierType === 'int. business' ||
                                    subEnqType === 'fleet' || subEnqType === 'government' || subEnqType === 'int. business') {

                                    const result = order.brands && Array.isArray(order.brands)
                                      ? order.brands.map((brand: any) => {
                                        if (brand === "Tradepoint" ||
                                          brand === "ALAC Tyres & Batteries" ||
                                          brand === "ALAC AfterMarket Parts" ||
                                          brand === "ALAC") {
                                          return "ALAC";
                                        }
                                        if (brand?.trim().toLowerCase() === "byd") {
                                          return "BYD";
                                        }
                                        return brand;
                                      }).join(', ')
                                      : order.brands
                                        ?.toString()
                                        ?.split(',')
                                        ?.map((b: any) => b.trim().toLowerCase() === "byd" ? "BYD" : b.trim())
                                        ?.join(', ');

                                    return result;
                                  }
                                   Default behavior for all other customer types
                                  const result = order.brands && Array.isArray(order.brands) && tierType && (tierType !== 'workshop' || subEnqType !== 'workshop') && subEnquiries && subEnqType !== 'tpcdealer'
                                    ? order.brands.map((brand: any) => {
                                      const mapped = brand === "Tradepoint" ? "ALAC" : brand === 'BYD' ? getNewBrand(brand) : brand;
                                      return mapped;
                                    }).join(', ')
                                    : order.brands
                                      ?.toString()
                                      ?.split(',')
                                      ?.map((b: any) => b.trim().toLowerCase() === "byd" ? "BYD" : b.trim())
                                      ?.join(', ');
                                  return result;
                                })()}
                              </TableCell> */}

                              {/* New logic by comparing salesoffice and customerType */}

                              <TableCell align="left" className={classes.bodyContent}>
                                {orderType === "new" ? (() => {
                                  const uniqueBrands = Array.from(
                                    new Set(
                                      order?.subEnquiries?.map((subEnq: any) =>
                                        getDisplayNameBySalesOffice(
                                          subEnq?.customerType || "",
                                          subEnq?.salesOffice || ""
                                        )
                                      ) || []
                                    )
                                  ).filter(Boolean) as string[];

                                  return uniqueBrands.map((displayLabel, index) => (
                                    <React.Fragment key={index}>
                                      {displayLabel === "Others (Tyres / Batteries / Lubes / IAM)" ? (
                                        <>
                                          <span className="fw-bold fs-5">Others</span>{" "}
                                          <span className="fs-6 text-muted">
                                            (Tyres / Batteries / Lubes / IAM)
                                          </span>
                                        </>
                                      ) : (
                                        displayLabel
                                      )}
                                      {index !== uniqueBrands.length - 1 && ", "}
                                    </React.Fragment>
                                  ));
                                })() : (() => {
                                  const tierType = customerTierType?.toLowerCase();
                                  const subEnqType = subEnquiries[0]?.customerType?.toLowerCase();
                                  if (subEnqType === 'tpcdealer' || tierType === 'tpcdealer' || tierType === 'workshop' || subEnqType === 'workshop') {
                                    return "Tradepoint";
                                  }
                                  if (tierType === 'fleet' || tierType === 'government' || tierType === 'int. business' ||
                                    subEnqType === 'fleet' || subEnqType === 'government' || subEnqType === 'int. business') {
                                    const result = order.brands && Array.isArray(order.brands)
                                      ? order.brands.map((brand: any) => {
                                        if (brand === "Tradepoint" || brand === "ALAC Tyres & Batteries" ||
                                          brand === "ALAC AfterMarket Parts" || brand === "ALAC") {
                                          return "ALAC";
                                        }
                                        if (brand?.trim().toLowerCase() === "byd") return "BYD";
                                        return brand;
                                      }).join(', ')
                                      : order.brands?.toString()?.split(',')
                                        ?.map((b: any) => b.trim().toLowerCase() === "byd" ? "BYD" : b.trim())
                                        ?.join(', ');
                                    return result;
                                  }
                                  const result = order.brands && Array.isArray(order.brands) && tierType &&
                                    (tierType !== 'workshop' || subEnqType !== 'workshop') &&
                                    subEnquiries && subEnqType !== 'tpcdealer'
                                    ? order.brands.map((brand: any) => {
                                      const mapped = brand === "Tradepoint" ? "ALAC" : brand === 'BYD' ? getNewBrand(brand) : brand;
                                      return mapped;
                                    }).join(', ')
                                    : order.brands?.toString()?.split(',')
                                      ?.map((b: any) => b.trim().toLowerCase() === "byd" ? "BYD" : b.trim())
                                      ?.join(', ');
                                  return result;
                                })()}
                              </TableCell>

                              {/* <TableCell align="left" className={classes.bodyContent}>
                                {(() => {
                                  const tierType = customerTierType?.toLowerCase();
                                  const subEnqType = subEnquiries[0]?.customerType?.toLowerCase();

                                  // Priority 1: TPC Dealer or Workshop → Always show "Tradepoint"
                                  if (subEnqType === 'tpcdealer' || tierType === 'tpcdealer' || 
                                      tierType === 'workshop' || subEnqType === 'workshop') {
                                    return "Tradepoint";
                                  }

                                  // Priority 2: Fleet, Government, Int. Business → Consolidate ALAC variants
                                  if (tierType === 'fleet' || tierType === 'government' || tierType === 'int. business' ||
                                      subEnqType === 'fleet' || subEnqType === 'government' || subEnqType === 'int. business') {
                                    
                                    if (!order.brands || !Array.isArray(order.brands)) {
                                      return order.brands?.toString() || '';
                                    }

                                    // Map all ALAC variants to "ALAC", keep others as-is
                                    const mappedBrands = order.brands.map((brand: any) => {
                                      if (brand === "Tradepoint" ||
                                          brand === "ALAC Tyres & Batteries" ||
                                          brand === "ALAC AfterMarket Parts" ||
                                          brand === "ALAC") {
                                        return "ALAC";
                                      }
                                      return brand;
                                    });

                                    // Remove duplicates and join
                                    const uniqueBrands = [...new Set(mappedBrands)];
                                    return uniqueBrands.join(', ');
                                  }

                                  // Priority 3: TBL Dealer - Show displayName from subEnquiry
                                  if (tierType === 'tbl dealer' || tierType === 'dealer' ||
                                      subEnqType === 'tbl dealer' || subEnqType === 'dealer') {
                                    
                                    // If all subEnquiries have the same displayName, show it
                                    if (subEnquiries && subEnquiries.length > 0) {
                                      const displayNames = subEnquiries
                                        .map((se: any) => se.displayName)
                                        .filter(Boolean);
                                      
                                      if (displayNames.length > 0) {
                                        const uniqueDisplayNames = [...new Set(displayNames)];
                                        return uniqueDisplayNames.join(', ');
                                      }
                                    }

                                    // Fallback to brands array
                                    return order.brands && Array.isArray(order.brands) 
                                      ? order.brands.join(', ')
                                      : order.brands?.toString() || '';
                                  }

                                  // Default: Convert "Tradepoint" to "ALAC" for non-workshop customers
                                  if (order.brands && Array.isArray(order.brands)) {
                                    const mappedBrands = order.brands.map((brand: any) => 
                                      brand === "Tradepoint" ? "ALAC" : brand
                                    );
                                    return mappedBrands.join(', ');
                                  }

                                  return order.brands?.toString() || '';
                                })()}
                              </TableCell> */}
                              <TableCell className={classes.bodyContent}>{parseFloat(getSellingPrice(!!order.estimatedTotal && order.estimatedTotal, isSellingPriceData, markupPercentage)).toFixed(2)}</TableCell>
                              {sessionStorage.getItem('userType') === 'FSE' ?
                                <TableCell className="mw-150p">
                                  <div className="dealer-table-content">{order.createdBy ? order.createdBy : "-"}</div>
                                  <div className="dealer-table-subcontent">{order.userRole === "FSE" ? "(Al-Futtaim)" : order.userRole ? (order.userRole) : "-"}</div>
                                </TableCell>
                                : <TableCell className="mw-150p">
                                  <div className="dealer-table-content">{order.createdBy ? order.createdBy : "-"}</div>
                                  <div className="dealer-table-subcontent">{(order.userRole === "FSE" || sessionStorage.getItem('userType') === 'sre') ? "(Al-Futtaim)" : order.userRole ? (order.userRole) : "-"}</div>
                                </TableCell>
                              }
                              <TableCell className={classes.bodyContent}>{moment(order.createdOn).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                              <TableCell className={(order.status === "Order Blocked" || order.status === "Order Blocked - Credit Issue" || order.status === "Order partially blocked for Credit Issue") ? classes.bodyContentRed : classes.bodyContent}>{order.status}</TableCell>
                              <TableCell>
                                {showViewEnquiry &&
                                  <Tooltip title="View Order Enquiry" placement="top" onClick={async () => {
                                    await dispatch(isVewingFromOrderHistory({ isViewingFromOrderHistory: true, id: order.masterId }))
                                  }}>
                                    <IconButton className={classes.actionButton} size="small" onClick={async () => {
                                      if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
                                        const kamEmail = sessionStorage.getItem('email');
                                        dispatch(getProfile(kamEmail, sessionStorage.getItem('userType') === 'sre' ? 'sre' : 'fse'));
                                      } else {
                                        const b2cUid: any = sessionStorage.getItem('userId');
                                        const userType: any = sessionStorage.getItem('userType');
                                        dispatch(getProfile(b2cUid, userType));
                                      }
                                      sessionStorage.setItem("partsData", "")
                                      sessionStorage.setItem('isCopyandCreate', "");
                                      sessionStorage.setItem('viewEnquiry', "true");
                                      sessionStorage.setItem('updateEnquiry', "");
                                      if (isAnnexurePartAccess && order.isAnnexureEnquiry === true && (customerTierType && customerTierType === 'Dealer' || customerTypeAccess.includes("dealer"))) {
                                        sessionStorage.setItem('annexureEnquiry', "true");
                                      } else {
                                        sessionStorage.setItem('annexureEnquiry', "");
                                      }
                                      if (sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre') {
                                        await dispatch(getCustomerDetailsByCustomerID(order?.customerId))
                                      }
                                      if (customerTierType.toLowerCase() === "dealer" || customerTierType.toLowerCase() === "workshop" || customerTierType.toLowerCase() === 'tpcdealer') {
                                        dispatch(getViewRequestStatusAPI(order.masterId))
                                      }
                                      sessionStorage.setItem('enquiryModeDetails', JSON.stringify({
                                        mode: 'view',
                                        masterId: order.masterId,
                                        orderType: "order",
                                        quotation: false
                                      }));
                                      await dispatch(isVewingFromOrderHistory({ isViewingFromOrderHistory: true, id: order.masterId }))
                                      dispatch(setPageNumber(page));
                                      history.push('/viewenquiry')
                                    }}>
                                      <AssignmentIcon fontSize="inherit" />
                                    </IconButton>
                                  </Tooltip>
                                }
                              </TableCell>
                            </TableRow>
                            <TableRow className={classes.collapseBg}>
                              <TableCell className="p-0 w-100" colSpan={12}>
                                {/* <Collapse in={shouldAutoExpand || open === index + 1}> */}
                                <Collapse in={open === index + 1 ? true : open === -(index + 2) ? false : shouldAutoExpand ? true : false}>                                  <Box>
                                  <Table aria-label="table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell className={classes.subTableHeadSmall}>
                                          {selectedOrder && selectedOrder.status && typeof selectedOrder.status === "string" && selectedOrder.status.toLowerCase() === 'order completed' && (
                                            <span className="orangedot"></span>
                                          )}
                                        </TableCell>
                                        <TableCell className={classes.subTableHead}>
                                          <span className="mx-2 ml-3"></span>
                                          Order No.</TableCell>
                                        <TableCell className={classes.subTableHead}>Reference No.</TableCell>
                                        <TableCell className={classes.subTableHead}>Brand</TableCell>
                                        <TableCell className={classes.subTableHead}>
                                          Total Amount
                                          <div className="text-muted font-10 font-weight-600">(incl. of Vat)</div>
                                        </TableCell>
                                        <TableCell className={classes.subTableHead}>Created By</TableCell>
                                        <TableCell className={classes.subTableHead}>Created On</TableCell>
                                        <TableCell className={classes.subTableHead}>Status</TableCell>
                                        <TableCell className={classes.subTableHead}>Payment Status</TableCell>
                                        <TableCell className={classes.subTableHead}>Action</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {!isEmpty(matchedSubEnquiries) && matchedSubEnquiries.map((subEnquiry: any) => {
                                        const canShowStatus = isString(subEnquiry.status);
                                        const showViewEnquiry = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre' ? true : !sessionStorage.getItem('restrictFeat')?.includes(RESTRICTED_ACCESS.VIEW_ORDERS);
                                        return <>
                                          <TableRow key={subEnquiry.isAirOrder ? subEnquiry.backOrderNumber : subEnquiry.orderNumber} className={isReturned ? classes.orangeRowHighlight : classes.subTableBodyContent}>
                                            <TableCell className={classes.subTableBodyContentSmall}>
                                              {subEnquiry.isAirOrder && <span className="ml-2 dot"></span>}
                                              {subEnquiry && subEnquiry.status && typeof subEnquiry.status === 'string' && subEnquiry.status.toLowerCase() === "return created" && <span className="ml-2 orangedot"></span>}
                                              {subEnquiry && subEnquiry.backOrderDetails && subEnquiry.backOrderDetails.length && subEnquiry.backOrderDetails.length > 0 && <span className="ml-2 orangedot"></span>}
                                            </TableCell>
                                            <TableCell className={classes.subTableBodyContent}>
                                              {subEnquiry.isAirOrder ? subEnquiry.backOrderNumber : subEnquiry.orderNumber}
                                            </TableCell>
                                            <TableCell className={classes.subTableBodyContent}>{subEnquiry.enquiryReferenceNumber}</TableCell>
                                            <TableCell className={classes.subTableBodyContent}>
                                              {getDisplayName(subEnquiry)}
                                              {/* {customerTierType.toLowerCase() === 'tpcdealer' || subEnquiry.customerType === 'tpcdealer' || subEnquiry.customerType?.toLowerCase() === 'workshop' || customerTierType.toLowerCase() === 'workshop' ? 'Tradepoint' 
                                                : (customerTierType === 'TBL Dealer' || subEnquiry.customerType?.toLowerCase() === 'tbl dealer' || customerTierType === 'Dealer' || subEnquiry.customerType?.toLowerCase() === 'dealer') ?
                                                 subEnquiry.displayName ? subEnquiry.displayName : subEnquiry.materialGroupCode === "ALPOE" ? 'ALAC AfterMarket Parts' : subEnquiry.materialGroupCode === "AMPTB" ? 'ALAC Tyres & Batteries' : getNewBrand(subEnquiry.make.toString()) === 'Tradepoint' && (customerTierType.toLowerCase() !== 'workshop' || subEnquiry.customerType !== 'workshop') && subEnquiry.customerType !== 'tpcdealer' ? 'ALAC' : getNewBrand(subEnquiry.make.toString())} */}
                                            </TableCell>
                                            <TableCell className={classes.subTableBodyContent}>{subEnquiry.orderNumber || subEnquiry.backOrderNumber ?
                                              (parseFloat(getSellingPrice(subEnquiry.estimatedTotal, isSellingPriceData, markupPercentage)).toFixed(2)) : (parseFloat(getSellingPrice(0, isSellingPriceData, markupPercentage)).toFixed(2))}</TableCell>
                                            <TableCell className={classes.subTableBodyContent}>{subEnquiry.userName}</TableCell>
                                            <TableCell className={classes.subTableBodyContent}>{moment(order.orderCreatedon).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss')}</TableCell>
                                            <TableCell className={(order.status === "Order Blocked" || subEnquiry.status === "Order Blocked" || order.status === "Order Blocked - Credit Issue" || subEnquiry.status === "Order Blocked - Credit Issue" || subEnquiry.status === "Order partially blocked for Credit Issue" || order.status === "Order partially blocked for Credit Issue") || subEnquiry.status === "NOT DELIVERED" ? classes.subTableBodyContentRed : classes.subTableBodyContent}>{canShowStatus && subEnquiry.status}</TableCell>
                                            <TableCell className={classes.subTableBodyContent}>{subEnquiry.status === "Fully Cancelled" ? "-" : subEnquiry.paymentStatus}</TableCell>
                                            <TableCell className={classes.subTableBodyContent}>
                                              {((subEnquiry.isAirOrder === false && subEnquiry.orderNumber && subEnquiry.orderNumber !== "-") || (subEnquiry.isAirOrder && subEnquiry.backOrderNumber)) && <IconButton onClick={(event: any) => {
                                                handleClick(event, subEnquiry, order); let brands: any = {
                                                  "Toyota": "2001",
                                                  "Honda": "2002",
                                                  "BYD": "2092",
                                                  "Famco": "2003",
                                                  "TE": "2380",
                                                  "OES": "2195",
                                                }
                                                sessionStorage.setItem('customerTierType', subEnquiry.customerType);
                                                setQuotationNumber(subEnquiry && subEnquiry.nowOrderDetails && subEnquiry.nowOrderDetails.quotationNumber ? subEnquiry && subEnquiry.nowOrderDetails.quotationNumber : subEnquiry && subEnquiry.backOrderDetails && subEnquiry.backOrderDetails.quotationNumber && subEnquiry.backOrderDetails.quotationNumber ? subEnquiry && subEnquiry.backOrderDetails.quotationNumber : "")
                                                setBrandId(brands[subEnquiry && subEnquiry.make])
                                                setEnquiryNumber(order.masterId);
                                              }} className={classes.actionButton} size="small">
                                                <MoreVertIcon fontSize="inherit" className={classes.actionButton} />
                                              </IconButton>}
                                            </TableCell>
                                          </TableRow>
                                          {selectedOrder && ((subEnquiry.isAirOrder === false && selectedOrder.orderNumber && selectedOrder.orderNumber === subEnquiry.orderNumber) || (subEnquiry.isAirOrder && selectedOrder.backOrderNumber === subEnquiry.backOrderNumber)) &&
                                            <Menu
                                              id="simple-menu"
                                              anchorEl={anchorEl}
                                              keepMounted
                                              open={Boolean(anchorEl)}
                                              onClose={handleClose}
                                            >
                                              {showViewEnquiry && <MenuItem onClick={() => {
                                                dispatch(getOrderId(selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber));
                                                sessionStorage.setItem('selectedOrderMake', selectedOrder.make);
                                                sessionStorage.setItem('selectedOrderEnquiryNumber', selectedOrder.enquiryNumber);
                                                sessionStorage.setItem('selectedOrderCreatedOn', moment(order.createdOn).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'));
                                                sessionStorage.setItem('userRoleCreatedBy', order.userRole);
                                                // dispatch(ViewDelivery({ ...selectedOrder, parentOrder: order }))
                                                dispatch(ViewDelivery({
                                                  ...selectedOrder,
                                                  backOrderNumber: selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : undefined,
                                                  parentOrder: order
                                                }))
                                                sessionStorage.setItem('isBackOrder', selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? 'true' : '');
                                                const tierType = sessionStorage.getItem('customerTierType')?.toLowerCase();

                                                const isDealer =
                                                  tierType === 'tbl dealer' ||
                                                  tierType === 'dealer';
                                                const brand =
                                                  isDealer && selectedOrder.displayName === 'BYD'
                                                    ? getNewBrand(selectedOrder.make?.toString())
                                                    : selectedOrder.displayName
                                                      ? selectedOrder.displayName
                                                      : selectedOrder.make
                                                        ? selectedOrder.make.toString()
                                                        : "";

                                                sessionStorage.setItem('orderStoredBrand', brand);
                                                // sessionStorage.setItem('orderStoredBrand', (sessionStorage.getItem('customerTierType') === 'TBL Dealer' || sessionStorage.getItem('customerTierType') === 'tbl dealer' || sessionStorage.getItem('customerTierType') === 'dealer' || sessionStorage.getItem('customerTierType') === 'Dealer') && selectedOrder.displayName === 'BYD' ? getNewBrand(selectedOrder.make.toString()) : selectedOrder.displayName : selectedOrder.make ? selectedOrder.make.toString() : "")
                                                sessionStorage.setItem('orderBackNumber', selectedOrder.backOrderNumber)
                                                if (selectedOrder.backOrderNumber || selectedOrder.orderNumber) {
                                                  history.push(`/orderdetails`);
                                                  sessionStorage.setItem('selectedCustomerID', selectedOrder && selectedOrder.customerId === undefined ? actualOrder && actualOrder.customerId : selectedOrder && selectedOrder.customerId)
                                                  dispatch(setPageNumber(page));
                                                  let brands: any = {
                                                    "Toyota": "2001",
                                                    "Honda": "2002",
                                                    "BYD": "2092",
                                                    "Famco": "2003",
                                                    "TE": "2380",
                                                    "OES": "2195",
                                                  }
                                                  lpoAttachments && lpoAttachments.length > 0 && lpoAttachments.map((ele: any) => {
                                                    sessionStorage.setItem('lpoAttachments', JSON.stringify({
                                                      documentId: ele.documentId,
                                                      lpoNumber: ele.lpoNumber,
                                                      uploadedBy: ele.uploadedBy,
                                                      uploadedOn: ele.uploadedOn,
                                                      url: ele.url
                                                    }));
                                                  });
                                                  sessionStorage.setItem("upload-lpoAttachments-url-view-order", "");
                                                  sessionStorage.setItem("upload-lpoAttachments-view-order", "");
                                                  dispatch(quotationDetailsViewOrder(
                                                    {
                                                      brandId: brands[selectedOrder && selectedOrder.make],
                                                      b2bEnquiryId: order.masterId,
                                                      orderNumber: subEnquiry.isAirOrder ? subEnquiry.backOrderNumber : subEnquiry.orderNumber
                                                    }
                                                  ))
                                                } handleClose()
                                              }}> <div className="pr-2">
                                                  <IconButton className={`${classes.actionButton} `} size="small">
                                                    <VisibilityIcon fontSize="inherit" />
                                                  </IconButton>
                                                </div>View Order</MenuItem>}
                                              {quotationNumber && (sessionStorage.getItem('userType') === 'FSE' || customerTierType !== '') && <MenuItem className="pl-3 pr-3" onClick={() => {
                                                handleViewQuotation()
                                              }}>
                                                <div className="pr-2">
                                                  <IconButton className={`${classes.actionButton} `} size="small">
                                                    <VisibilityIcon fontSize="inherit" />
                                                  </IconButton>
                                                </div>
                                                View Quotation</MenuItem>}
                                              {(sessionStorage.getItem('userType') === 'FSE' && customerTierType === 'tbl dealer') || sessionStorage.getItem('userType') === 'sre' ? " " :
                                                <>
                                                  {/* {((lpoAttachments && lpoAttachments.length > 0 || quotationNumber) && (sessionStorage.getItem('userType') === 'FSE' || customerTierType !== '')) && */}
                                                  {sessionStorage.getItem('customerOnboardingType') === 'TBL Dealer' ? "" :
                                                    <>
                                                      {((lpoAttachments && lpoAttachments.length > 0) && (sessionStorage.getItem('userType') === 'FSE' || customerTierType !== '')) &&
                                                        <MenuItem className="pl-3 pr-3" onClick={() => {
                                                          handleViewLPO(selectedOrder && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber, subEnquiry && subEnquiry.isAirOrder ? subEnquiry.backOrderDetails.quotationNumber : subEnquiry.nowOrderDetails.quotationNumber);
                                                          let brands: any = {
                                                            "Toyota": "2001",
                                                            "Honda": "2002",
                                                            "BYD": "2092",
                                                            "Famco": "2003",
                                                            "TE": "2380",
                                                            "OES": "2195",
                                                          }
                                                          lpoAttachments && lpoAttachments.map((ele: any) => {
                                                            sessionStorage.setItem('lpoAttachments', JSON.stringify({
                                                              documentId: ele.documentId,
                                                              lpoNumber: ele.lpoNumber,
                                                              uploadedBy: ele.uploadedBy,
                                                              uploadedOn: ele.uploadedOn,
                                                              url: ele.url
                                                            }));
                                                          });
                                                          dispatch(quotationDetailsViewOrder(
                                                            {
                                                              brandId: brands[selectedOrder && selectedOrder.make],
                                                              b2bEnquiryId: order.masterId,
                                                              orderNumber: selectedOrder && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber,
                                                              quotationNumber: quotationNumber ? quotationNumber : selectedOrder && selectedOrder.nowOrderDetails.quotationNumber
                                                            }
                                                          ))
                                                          setOrderNumber(selectedOrder && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber);
                                                          sessionStorage.setItem('SubEnquiry-Status', subEnquiry.status);
                                                        }}>
                                                          <div className="pr-2">
                                                            <IconButton className={`${classes.actionButton} `} size="small">
                                                              <VisibilityIcon fontSize="inherit" />
                                                            </IconButton>
                                                          </div>
                                                          View LPO</MenuItem>}
                                                      {(((lpoAttachments && lpoAttachments.length === 0 && quotationNumber === '') && (sessionStorage.getItem('userType') === 'FSE' || customerTierType !== ''))) && (
                                                        <>
                                                          {(subEnquiry.status !== "Partially Invoiced" && subEnquiry.status !== "Fully Invoiced" &&
                                                            subEnquiry.status !== "Fully delivered" &&
                                                            subEnquiry.status !== "Partially delivered" &&
                                                            subEnquiry.status !== "Partially delivered" && subEnquiry.status !== "Delivery Processing" &&
                                                            !(subEnquiry && subEnquiry.nowOrderDetails && subEnquiry.nowOrderDetails.quotationNumber)) && ((sessionStorage.getItem('userType') === 'FSE' || customerTierType !== '')) && <MenuItem onClick={() => {
                                                              let brands: any = {
                                                                "Toyota": "2001",
                                                                "Honda": "2002",
                                                                "BYD": "2092",
                                                                "Famco": "2003",
                                                                "TE": "2380",
                                                                "OES": "2195",
                                                              }
                                                              setOpenUploadLpo(true);
                                                              dispatch(quotationDetailsViewOrder(
                                                                {
                                                                  brandId: brands[selectedOrder && selectedOrder.make],
                                                                  b2bEnquiryId: order.masterId,
                                                                  orderNumber: subEnquiry.isAirOrder ? subEnquiry.backOrderNumber : subEnquiry.orderNumber,
                                                                  quotationNumber: quotationNumber ? quotationNumber : subEnquiry && subEnquiry.nowOrderDetails.quotationNumber
                                                                }
                                                              ))
                                                            }} className="quotation-text">
                                                              <div className="pr-2">
                                                                <IconButton className="exportExcel" size="small" >
                                                                  <ArrowUpwardIcon style={{ border: "2px solid #1A9FE0", borderRadius: "8px" }} fontSize="inherit" onClick={() => { }} />
                                                                </IconButton>
                                                              </div>
                                                              Upload LPO
                                                              <div>
                                                                <div className="pr-2">
                                                                  <IconButton className={`${classes.actionButton} `} size="small">
                                                                    <div className="">
                                                                      <Tooltip title="Order will not be processed by Al-Futtaim unless LPO is uploaded." placement="top">
                                                                        <HelpIcon className="float-right" fontSize="inherit" />
                                                                      </Tooltip>
                                                                    </div>
                                                                  </IconButton>
                                                                </div>
                                                              </div>
                                                            </MenuItem>}
                                                        </>
                                                      )}
                                                    </>
                                                  }
                                                </>}
                                              {selectedOrder && selectedOrder.status && typeof selectedOrder.status == "string" &&
                                                <>
                                                  {showViewDelivery && viewDeliveryOrderStatuses.includes(selectedOrder.status.toLowerCase()) &&
                                                    <MenuItem onClick={async () => {
                                                      let sapId: any = actualOrder && actualOrder?.customerId?.trim() ? actualOrder.customerId : selectedOrder?.customerId?.trim() ? selectedOrder?.customerId : sessionStorage.getItem('selectedCustomerID')
                                                      const salesDocument = (selectedOrder.isAirOrder && selectedOrder.backOrderNumber)
                                                        ? selectedOrder.backOrderNumber
                                                        : selectedOrder.orderNumber;
                                                      let data: any = await dispatch(getDeliveryList(salesDocument, selectedOrder.enquiryNumber, selectedOrder.make, selectedOrder.backOrderNumber, sapId, selectedOrder.orgid));
                                                      sessionStorage.setItem('selectedOrderMake', selectedOrder.make);
                                                      sessionStorage.setItem('selectedOrderOrgId', (selectedOrder.orgid || order?.orgid || subEnquiry?.orgid || '').toString());
                                                      sessionStorage.setItem('selectedOrderEnquiryNumber', selectedOrder.enquiryNumber);
                                                      sessionStorage.setItem('selectedOrderCreatedOn', moment(order.createdOn).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'));
                                                      sessionStorage.setItem('userRoleCreatedBy', order.userRole);
                                                      dispatch(ViewDelivery({
                                                        ...selectedOrder,
                                                        orgid: selectedOrder.orgid || order?.orgid || subEnquiry?.orgid,
                                                        backOrderNumber: selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : undefined,
                                                        parentOrder: order
                                                      }))
                                                      if (data && data.error) {
                                                        handleopenCloseSnackbar(true);
                                                        setOpenErrorSnackbar(true)
                                                        setSuccessMessage(data && data.message && data.message.message)
                                                      }
                                                      else {
                                                        setOpenErrorSnackbar(false)
                                                        dispatch(selectedViewDelivery({ enquiryNumber: subEnquiry.enquiryNumber, make: subEnquiry.make, orgId: subEnquiry.orgid }));
                                                        history.push(`/deliverylist`);
                                                      }
                                                      handleClose()
                                                    }}> <div className="pr-2">
                                                        <IconButton className={`${classes.actionButton} `} size="small">
                                                          <VisibilityIcon fontSize="inherit" />
                                                        </IconButton>
                                                      </div>View Delivery & Invoice</MenuItem>
                                                  }
                                                  {(() => {
                                                    const isFSE = sessionStorage.getItem('userType') === 'FSE';
                                                    const isIBUser =
                                                      (isFSE && (
                                                        sessionStorage.getItem('customerTierType')?.toLowerCase() === 'int. business' ||
                                                        selectedOrder?.customerType?.toLowerCase() === 'int. business'
                                                      )) ||
                                                      customerTierType?.toLowerCase() === 'int. business' ||
                                                      selectedOrder?.customerType?.toLowerCase() === 'int. business';

                                                    const orderCreatedFor = order?.salesData?.orderCreatedFor?.toString().trim().toUpperCase();
                                                    const isMultiAutoOrder = orderCreatedFor === 'MA';

                                                    let canShowSalesReturn = true;

                                                    if (isIBUser || isMultiAutoOrder) {
                                                      const orderOrgId = order?.orgid || selectedOrder?.orgid || subEnquiry?.orgid;
                                                      const hasOrgId = orderOrgId !== undefined && orderOrgId !== null && orderOrgId?.toString().trim() !== '';
                                                      const isArchAutoOrder = hasOrgId
                                                        ? orderOrgId?.toString().trim() === '2428'
                                                        : orderCreatedFor === 'AA';

                                                      console.log('DEBUG Request-a-Return gating', { isFSE, isIBUser, isMultiAutoOrder, orderOrgId, hasOrgId, orderCreatedFor, isArchAutoOrder, order, selectedOrder, subEnquiry });

                                                      if (isFSE) {
                                                        canShowSalesReturn = isArchAutoOrder === true;
                                                      } else {
                                                        canShowSalesReturn = isSalesReturnAccess === true && isArchAutoOrder === true;
                                                      }
                                                    } else if (!isFSE) {
                                                      canShowSalesReturn = isSalesReturnAccess === true;
                                                    }

                                                    return showViewDelivery && viewDeliveryOrderStatuses.includes(selectedOrder.status.toLowerCase()) &&
                                                      canShowSalesReturn &&
                                                      <MenuItem onClick={async () => {
                                                        let sapId: any = actualOrder && actualOrder?.customerId?.trim() ? actualOrder.customerId : selectedOrder?.customerId?.trim() ? selectedOrder?.customerId : sessionStorage.getItem('selectedCustomerID')
                                                        const salesDocument = (selectedOrder.isAirOrder && selectedOrder.backOrderNumber)
                                                          ? selectedOrder.backOrderNumber
                                                          : selectedOrder.orderNumber;
                                                        let data: any = await dispatch(getDeliveryList(salesDocument, selectedOrder.enquiryNumber, selectedOrder.make, selectedOrder.backOrderNumber, sapId, selectedOrder.orgid));
                                                        sessionStorage.setItem('selectedOrderMake', selectedOrder.make);
                                                        sessionStorage.setItem('selectedOrderOrgId', (selectedOrder.orgid || order?.orgid || subEnquiry?.orgid || '').toString());
                                                        sessionStorage.setItem('selectedOrderEnquiryNumber', selectedOrder.enquiryNumber);
                                                        sessionStorage.setItem('selectedOrderCreatedOn', moment(order.createdOn).tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss'));
                                                        sessionStorage.setItem('userRoleCreatedBy', order.userRole);
                                                        dispatch(ViewDelivery({
                                                          ...selectedOrder,
                                                          orgid: selectedOrder.orgid || order?.orgid || subEnquiry?.orgid,
                                                          backOrderNumber: selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : undefined,
                                                          parentOrder: order
                                                        }))
                                                        if (data && data.error) {
                                                          handleopenCloseSnackbar(true);
                                                          setOpenErrorSnackbar(true)
                                                          setSuccessMessage(data && data.message && data.message.message)
                                                        }
                                                        else {
                                                          setOpenErrorSnackbar(false)
                                                          dispatch(selectedViewDelivery({ enquiryNumber: subEnquiry.enquiryNumber, make: subEnquiry.make, orgId: subEnquiry.orgid }));
                                                          history.push(`/deliverylist`);
                                                        }
                                                        handleClose()
                                                      }}> <div className="pr-2">
                                                          <IconButton className={classes.actionButton} size="small" style={{ color: "#fbc02d" }} >
                                                            <ReplayIcon fontSize="inherit" />
                                                          </IconButton>
                                                        </div>Request a Return</MenuItem>;
                                                  })()}
                                                  {/* {viewReturnRequestStatuses.includes(selectedOrder.status.toLowerCase()) &&
                                                      <MenuItem onClick={() => {
                                                        handleopenCloseReturnRequest(true);
                                                        handleClose();
                                                        dispatch(getOrderId(subEnquiry.backOrderNumber && !subEnquiry.orderNumber ? subEnquiry.backOrderNumber : subEnquiry.orderNumber));
                                                      }}>Return Order</MenuItem>
                                                    } */}
                                                  {shouldHideMakePaymentButton || sessionStorage.getItem('userType') === 'sre' ? "" :
                                                    <>
                                                      {(sessionStorage.getItem('userType') === 'FSE' && (order?.salesData?.orderType === 'CRD' || order.customerAccountType === 'Credit')) || ((customerTierType.toLowerCase() === "tpcdealer" || customerTierType.toLowerCase() === "workshop") && customerAccountType === 'Credit') ? '' :
                                                        <>
                                                          {(customerTierType && customerTierType.toLowerCase() === "fleet" || customerTierType === "Fleet" || customerTierType && customerTierType.toLowerCase() === "government" || customerTierType === "Government" || customerTierType && customerTierType.toLowerCase() === "int. business" || (sessionStorage.getItem('userType') === 'FSE' && (sessionStorage.getItem('customerTierType')?.toLowerCase() === 'int. business' || selectedOrder?.customerType?.toLowerCase() === 'int. business')) || (sessionStorage.getItem('userType') === 'FSE' && sessionStorage.getItem('orderStoredBrand') !== "OES")) ? ""
                                                            :
                                                            <>
                                                              {(status24 == "Fully Cancelled") ? '' :
                                                                <>
                                                                  {showViewEnquiry && selectedOrder && selectedOrder.paymentStatus == "Payment Received" || selectedOrder && selectedOrder.paymentStatus == "Credit Utilized" || selectedOrder.paymentStatus == "Offline Payment Pending" || goodsStatus == 'Completed' || selectedOrder.paymentStatus == "Offline Payment Pending (Payment at Counter)" || selectedOrder && selectedOrder.paymentStatus == "Offline Payment Pending (Credit card at delivery )" || !isSellingPriceData ?
                                                                    showViewEnquiry && selectedOrder && selectedOrder.paymentStatus && status24 != "Fully Cancelled" && (<MenuItem onClick={async () => {
                                                                      // sessionStorage.setItem('selectedOrderMake', selectedOrder.make);
                                                                      dispatch(getOrderId(selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber));
                                                                      setOrder({ ...selectedOrder, parentOrder: order })
                                                                      setPayment(true);
                                                                      dispatch(getCreditLimit(sessionStorage.getItem('userType') === 'FSE' ? actualOrder && actualOrder.customerId : sapCustomerId, webApplicationLoginId));
                                                                      // let orderNumber = getParameterByName('orderNo')
                                                                      let orderNumber1 = selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber
                                                                      if (order.masterId) {
                                                                        dispatch(getOrderSummaryDetails({ customerType: customerTierType, masterId: order.masterId, orderNumber1: orderNumber1 }))
                                                                        dispatch(getOrderSummary(customerTierType, order.masterId, orderNumber1))
                                                                      } else {
                                                                        dispatch(getOrderSummaryDetails({ customerType: customerTierType, masterId: order.masterId, orderNumber1: orderNumber1 }))
                                                                        dispatch(getOrderSummary(customerTierType, order.masterId, orderNumber1))
                                                                      }
                                                                      window.history.replaceState(null, "title", "/orderhistorypayment")
                                                                      window.history.replaceState(null, "title", "/orderhistorypayment")
                                                                      sessionStorage.setItem('isBackOrder', selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? 'true' : '');
                                                                      // sessionStorage.setItem('orderStoredBrand', selectedOrder.make.toString())
                                                                      sessionStorage.setItem('orderStoredBrand', (sessionStorage.getItem('customerTierType') === 'TBL Dealer' || sessionStorage.getItem('customerTierType') === 'tbl dealer' || sessionStorage.getItem('customerTierType') === 'dealer' || sessionStorage.getItem('customerTierType') === 'Dealer') && selectedOrder.displayName ? selectedOrder.displayName : selectedOrder.make ? selectedOrder.make.toString() : "")
                                                                      sessionStorage.setItem('orderBackNumber', selectedOrder.backOrderNumber)
                                                                      if (selectedOrder.backOrderNumber || selectedOrder.orderNumber) {
                                                                        //  history.push(`/orderdetails`);
                                                                        dispatch(setPageNumber(page));
                                                                        let userData: any;
                                                                        if (sessionStorage.getItem('userType') === 'FSE' && sessionStorage.getItem('customerTypeofCustomer') === "workshop") {
                                                                          userData = await dispatch(getCustomerDetailsByCustomerID(actualOrder && actualOrder.customerId));
                                                                          sessionStorage.setItem("companyCurrencyType", userData && userData.data && userData.data.companyCurrencyType)
                                                                        }
                                                                      } handleClose()
                                                                    }}> <div className="pr-2">
                                                                        <IconButton className={`${classes.actionButton} `} size="small">
                                                                          <VisibilityIcon fontSize="inherit" />
                                                                        </IconButton>
                                                                      </div>View Payment</MenuItem>)
                                                                    :
                                                                    showViewEnquiry && selectedOrder && selectedOrder.paymentStatus == "Payment Due" || goodsStatus != 'Completed' || showViewEnquiry && selectedOrder && selectedOrder.paymentStatus == "Declined" && status24 != "Fully Cancelled" ?
                                                                      showViewEnquiry && selectedOrder && selectedOrder.paymentStatus && (<MenuItem onClick={async () => {
                                                                        // sessionStorage.setItem('selectedOrderMake', selectedOrder.make);
                                                                        dispatch(getOrderId(selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber));
                                                                        setOrder({ ...selectedOrder, parentOrder: order })
                                                                        setPayment(true);
                                                                        dispatch(getCreditLimit(sessionStorage.getItem('userType') === 'FSE' ? actualOrder && actualOrder.customerId : sapCustomerId, webApplicationLoginId));
                                                                        // let orderNumber = getParameterByName('orderNo')
                                                                        let orderNumber1 = selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder.orderNumber
                                                                        if (order.masterId) {
                                                                          dispatch(getOrderSummaryDetails({ customerType: customerTierType, masterId: order.masterId, orderNumber1: orderNumber1 }))
                                                                          dispatch(getOrderSummary(customerTierType, order.masterId, orderNumber1))
                                                                        } else {
                                                                          dispatch(getOrderSummaryDetails({ customerType: customerTierType, masterId: order.masterId, orderNumber1: orderNumber1 }))
                                                                          dispatch(getOrderSummary(customerTierType, order.masterId, orderNumber1))
                                                                        }
                                                                        window.history.replaceState(null, "title", "/orderhistorypayment")
                                                                        window.history.replaceState(null, "title", "/orderhistorypayment")
                                                                        sessionStorage.setItem('isBackOrder', selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? 'true' : '');
                                                                        // sessionStorage.setItem('orderStoredBrand', selectedOrder.make.toString())
                                                                        sessionStorage.setItem('orderStoredBrand', (sessionStorage.getItem('customerTierType') === 'TBL Dealer' || sessionStorage.getItem('customerTierType') === 'tbl dealer' || sessionStorage.getItem('customerTierType') === 'dealer' || sessionStorage.getItem('customerTierType') === 'Dealer') && selectedOrder.displayName ? selectedOrder.displayName : selectedOrder.make ? selectedOrder.make.toString() : "")
                                                                        sessionStorage.setItem('orderBackNumber', selectedOrder.backOrderNumber)
                                                                        if (selectedOrder.backOrderNumber || selectedOrder.orderNumber) {
                                                                          //  history.push(`/orderdetails`);
                                                                          dispatch(setPageNumber(page));
                                                                          let userData: any;
                                                                          if (sessionStorage.getItem('userType') === 'FSE' && sessionStorage.getItem('customerTypeofCustomer') === "workshop") {
                                                                            userData = await dispatch(getCustomerDetailsByCustomerID(actualOrder && actualOrder.customerId));
                                                                            sessionStorage.setItem("companyCurrencyType", userData && userData.data && userData.data.companyCurrencyType)
                                                                          }
                                                                        } handleClose()
                                                                      }}><div className="pr-2">
                                                                          <IconButton className="exportExcel " size="small" >
                                                                            <ArrowForwardIcon className={` ${classes.actionRequest}`} style={{ border: "2px solid #1A9FE0", borderRadius: "8px" }} fontSize="inherit" onClick={() => { }} />
                                                                          </IconButton>
                                                                        </div>Make Payment</MenuItem>)
                                                                      : ""}
                                                                </>}
                                                            </>}
                                                        </>
                                                      }
                                                    </>
                                                  }
                                                  {/* {showViewInvoice && viewViewInvoiceStatuses.includes(selectedOrder.status.toLowerCase()) && selectedOrder && selectedOrder.status === "Fully Invoiced" ?
                                                      ""
                                                      :
                                                      showViewInvoice && viewViewInvoiceStatuses.includes(selectedOrder.status.toLowerCase()) &&
                                                      <MenuItem
                                                        disabled={!isSellingPriceData}
                                                        onClick={() => { getInvoiceDetails(selectedOrder); handleClose() }}>View Invoice
                                                      </MenuItem>
                                                    } */}
                                                </>
                                              }
                                            </Menu >
                                          }
                                        </>
                                      })}
                                    </TableBody >
                                  </Table>
                                </Box>
                                </Collapse>
                              </TableCell >
                            </TableRow >
                          </React.Fragment >
                        );
                      })}
                    </TableBody>
                  </Table>
                  {isEmpty(orders) &&
                    <div className="mt-5 justify-content-center mx-auto text-center d-flex">No Orders Found.</div>
                  }
                </TableContainer>
                <div className="col-12 d-flex justify-content-end">
                  <TablePagination
                    className="pagination"
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={totalOrderCount ? totalOrderCount : 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                  />
                </div>
              </div>
            </div>
          </div>

        </> : <>
          {payment &&
            <OrderHistoryPayment
              open={Order}
              orderData={Order}
              handleClickOpen={handleClickOpen}
              orderTotal={Order && Order.totalCost}
              getEstimatedTotal={2727}
            // handleopenClose={(data: any) => {
            //   history.push("/orderhistory");
            //    handleopenCloseOrderSummary(false);
            // }} 

            />
          }  </>

      }
      {/* <OrderSummaryDialog
       
     /> */}
      <Dialog className="pb-0"
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth="sm"
      >
        <HistoryMakePaymentDialog orderData={Order} setSuccessMessage={setSuccessMessage}
          setOpenErrorSnackbar={setOpenErrorSnackbar}
          openErrorSnackbar={openErrorSnackbar}
          handleopenCloseSnackbar={handleopenCloseSnackbar} setOpenDialog={handleCloseDialog}
        />
      </Dialog>
      <OrderHistoryViewQuotation openViewQuotation={openViewQuotation} handleCloseViewQuotation={handleCloseViewQuotation} viewQuotationUrl={viewQuotationUrl} brandId={brandId} enquiryNumber={enquiryNumber} quotationNumber={quotationNumber} sapCustomerId={sessionStorage.getItem('userType') === 'FSE' ? actualOrder && actualOrder.customerId : sapCustomerId} />
      <UploadLpoViewOrder orderNumber={selectedOrder && selectedOrder.backOrderNumber && selectedOrder.isAirOrder ? selectedOrder.backOrderNumber : selectedOrder && selectedOrder.orderNumber ? selectedOrder.orderNumber : orderNumber} quotationNumber={quotationNumber} openUploadLpo={openUploadLpo} handleUploadLpo={handleUploadLpo} sapCustomerId={sessionStorage.getItem('userType') === 'FSE' ? actualOrder && actualOrder.customerId : sapCustomerId} />
      <OrderHistoryViewLPO openViewLPO={openViewLPO} handleCloseViewLPO={handleCloseViewLPO} quotationNumber={quotationNumber} orderNumber={orderNumber} enquiryNumber={enquiryNumber} viewQuotationUrl={viewQuotationUrl} updateLPO={updateLPO} sapCustomerId={sessionStorage.getItem('userType') === 'FSE' ? actualOrder && actualOrder.customerId : sapCustomerId} fileExtension={fileExtention} />
    </Fragment >
  );
};

export default OrderHistory;
